import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { setJSONLocalStorage, getJSONLocalStorage, getToken } from '../../functions/app_functions.js';
import { trackEvent } from "../../utils/analytics";
import withRouter from '../../with_router.js';
import Activity from './activity.js';
import Review from './review.js';
import ReviewCreate from './review_create.js';
import Purchase from './purchase.js';
import PictureCarousel from './picture_carousel.js';
import TripPicture from './trip_picture.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import MissingPage from '../error/missingpage.js';
import TripMap from './trip_map.js';
import QRcode from './qrcode.js';
import TripNavigationBar from './trip_navigation_bar.js';
import { format_month_year, format_price } from '../../functions/functions_formatting.js';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconClose } from '../../media/icons/close.svg';
import { ReactComponent as IconEdit } from '../../media/icons/edit.svg';
import { ReactComponent as IconDelete } from '../../media/icons/delete.svg';
import { ReactComponent as IconAdd } from '../../media/icons/plus.svg';
import { ReactComponent as IconCheckmark } from '../../media/icons/checkmark.svg';
import { ReactComponent as IconStar } from '../../media/icons/star.svg';


class Trip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: {},
            verify_status: false,
            active_index: 1,
            map_expanded: false,
            map_loaded: false,
            login: false,
            user_id: "",
            owner: null,
            popup: {
                page: "",
                segment: "",
                activity: "",
                picture: ""
            },
            editing: {
                page: "",
                segment: "",
                segment_new: "",
                activities_category: "",
                activity: "",
                activity_new: "",
                picture: ""
            },
            editing_history: [],
            pictures: [],
            picture: 0,
            uploading: false,
            upload_image_file: null,
            fileLink: "",
            delete_picture: null,
            activity_address_method: "search",
            delete_description: null,
            delete_link: null,
            delete_segment: false,
            delete_activity: false,
            delete_trip: false,
            changes: false,
            segment_dragging: null,
            segment_dropTarget: null,
            activity_dragging: null,
            activity_dropTarget: null,
            activity_selected: null,
            activity_location_search: "",
            locations: this.props.locations,
            activity_categories: this.props.activity_categories,
            trip_categories: this.props.trip_categories,
            trip_targets: this.props.trip_targets,
            trip_pricing: this.props.trip_pricing,
            trip_timing: this.props.trip_timing,
            trip_duration: this.props.trip_duration,
            loaded: false
        };

        this.baseUrl = this.props.baseUrl;
        this.sectionRefs = {};
        this.observer = null;

        /* Functions to and upload usage data */
        this.loadData = this.loadData.bind(this);
        this.logTripView = this.logTripView.bind(this);
        this.handleTripUnlock = this.handleTripUnlock.bind(this);
        this.handleReviewCreate = this.handleReviewCreate.bind(this);
        this.handlePurchase = this.handlePurchase.bind(this);

        /* Functions to navigate the component */
        this.scrollToSection = this.scrollToSection.bind(this);

        /* Functions for component management */
        this.setPicture = this.setPicture.bind(this);
        this.setPopup = this.setPopup.bind(this);
        this.unsetPopup = this.unsetPopup.bind(this);
        this.setPopupPicture = this.setPopupPicture.bind(this);
        this.unsetPopupPicture = this.unsetPopupPicture.bind(this);
        this.setEditing = this.setEditing.bind(this);
        this.unsetEditing = this.unsetEditing.bind(this);
        this.goBackEditing = this.goBackEditing.bind(this);
        this.calculateAge = this.calculateAge.bind(this);
        this.setDeleteTrip = this.setDeleteTrip.bind(this);
        this.deleteTrip = this.deleteTrip.bind(this);

        /* Functions for editing trip content */
        this.handleFileChangePicture = this.handleFileChangePicture.bind(this);
        this.addPicture = this.addPicture.bind(this);
        this.addPictureActivity = this.addPictureActivity.bind(this);
        this.setDeletePicture = this.setDeletePicture.bind(this);
        this.deletePicture = this.deletePicture.bind(this);
        this.deletePictureActivity = this.deletePictureActivity.bind(this);
        this.toggleTripCategory = this.toggleTripCategory.bind(this);
        this.toggleTargetGroup = this.toggleTargetGroup.bind(this);
        this.togglePricingCategory = this.togglePricingCategory.bind(this);
        this.toggleTimingCategory = this.toggleTimingCategory.bind(this);
        this.toggleDurationCategory = this.toggleDurationCategory.bind(this);
        this.updateTitle = this.updateTitle.bind(this);
        this.addDescription = this.addDescription.bind(this);
        this.updateDescription = this.updateDescription.bind(this);
        this.setDeleteDescription = this.setDeleteDescription.bind(this);
        this.deleteDescription = this.deleteDescription.bind(this);
        this.addLink = this.addLink.bind(this);
        this.updateLink = this.updateLink.bind(this);
        this.setDeleteLink = this.setDeleteLink.bind(this);
        this.deleteLink = this.deleteLink.bind(this);
        this.handleDragEndActivities = this.handleDragEndActivities.bind(this);
        this.addSegment = this.addSegment.bind(this);
        this.setDeleteSegment = this.setDeleteSegment.bind(this);
        this.deleteSegment = this.deleteSegment.bind(this);
        this.updateSegmentLabel = this.updateSegmentLabel.bind(this);
        this.updateSegmentContent = this.updateSegmentContent.bind(this);
        this.addActivity = this.addActivity.bind(this);
        this.changeActivityAddressMethod = this.changeActivityAddressMethod.bind(this);
        this.setDeleteActivity = this.setDeleteActivity.bind(this);
        this.deleteActivity = this.deleteActivity.bind(this);
        this.updateActivity = this.updateActivity.bind(this);
        this.updateLocationSearch = this.updateLocationSearch.bind(this);
        this.searchLocation = this.searchLocation.bind(this);
        this.setSetting = this.setSetting.bind(this);
        this.updatePictureTitle = this.updatePictureTitle.bind(this);
        this.updatePicturePriority = this.updatePicturePriority.bind(this);
        this.updatePictureSegment = this.updatePictureSegment.bind(this);
        this.updatePictureActivity = this.updatePictureActivity.bind(this);
        this.handleDragEndPictures = this.handleDragEndPictures.bind(this);

        /* Functions to update trip data */
        this.verifyData = this.verifyData.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.submitUpdateTripData = this.submitUpdateTripData.bind(this);

        /* Functions to integrate Google Maps */
        this.toggleMap = this.toggleMap.bind(this);
        this.selectMapMarker = this.selectMapMarker.bind(this);
    }


    async componentDidMount() {
        try {
            await this.props.setLoading("trip_componentDidMount");
            var trip_id = this.props.params.tripid;
            /* var trip_id = this.props.match.params.tripid; */
            await this.setState({
                trip_id: trip_id,
                login: this.props.login,
                user_id: this.props.user_id
            });
            await this.props.unsetLoading("trip_componentDidMount");
            await this.loadData(trip_id);
            /* var verify_status = this.state.verify_status;
            if (this.state.data && this.state.data.trip_id && this.state.data.unlocked) {
                verify_status = await this.verifyData(this.state.data);
            }
            await this.setState({
                verify_status: verify_status
            }, this.setupObserver); */
            await this.setState({}, this.setupObserver);
            this.logTripView(this.props.user_id, trip_id);
        } catch (error) {
        } finally {
            await this.props.unsetLoading("trip_componentDidMount", true);
            await this.setState({
                loaded: true
            });
        }
    }


    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }


    async componentDidUpdate() {
        if (this.state.locations !== this.props.locations) {
            this.setState({
                locations: this.props.locations,
                activity_categories: this.props.activity_categories,
                trip_categories: this.props.trip_categories,
                trip_targets: this.props.trip_targets,
                trip_pricing: this.props.trip_pricing,
                trip_timing: this.props.trip_timing,
                trip_duration: this.props.trip_duration
            });
        }
    }


    scrollToSection(index) {
        if (this.sectionRefs[index].current) {
            this.sectionRefs[index].current.scrollIntoView({ behavior: "smooth" });
        }
    }


    setupObserver = () => {
        if (!this.state.data) return;
        if (!this.state.data.trip_id) return;
        if (!this.state.data.segments.length) return;
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    // Only consider sections that are in the viewport (entry.isIntersecting)
                    if (entry.isIntersecting) {
                        const index = Number(entry.target.dataset.index); // Get the index of the section
                        // Update the active_index only when a new section becomes visible
                        if (this.state.active_index !== index) {
                            this.setState({ active_index: index });
                        }
                    }
                });
            },
            { threshold: 0.1 } // Trigger when 50% of the section is visible
        );

        // Observe all sections
        Object.values(this.sectionRefs).forEach((ref) => {
            if (ref.current) {
                this.observer.observe(ref.current);
            }
        });
    };


    async loadData(trip_id) {
        try {
            this.props.setLoading("trip_loadData");
            var tripdata_data = getJSONLocalStorage(trip_id + "_tripdata_data", 1);
            var tripdata_pictures = getJSONLocalStorage(trip_id + "_tripdata_pictures", 1);
            if (tripdata_data && tripdata_data.trip_id && tripdata_data.trip_id.length > 0) {
                // Create refs to sections
                tripdata_data.segments.forEach((segment, index) => {
                    this.sectionRefs[segment.order] = createRef();
                });
                this.setState({
                    data: tripdata_data,
                    pictures: tripdata_pictures
                });
                // Set ownership status to state
                if (tripdata_data.owner_id == this.state.user_id) {
                    this.setState({
                        owner: true
                    });
                } else {
                    this.setState({
                        owner: false
                    });
                }
                this.props.unsetLoading("trip_loadData");
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/gettripdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    trip_id: trip_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.trip_id) {
                // Prepare list of pictures
                var pictures = [];
                var counter_pictures = 0;
                /* if (data.owner_id == this.state.user_id || data.unlocked) { */
                if (data.owner_id == this.state.user_id) {
                    pictures = pictures.concat(data.pictures);
                    data.segments.forEach(segment => {
                        segment.activities.forEach(activity => {
                            activity.pictures.forEach(picture => {
                                var pic = picture;
                                pic.type = "activity";
                                pic.category = picture.category ? picture.category : activity.category;
                                pic.subcategory = picture.subcategory ? picture.subcategory : activity.subcategory;
                                pic.subsubcategory = picture.subsubcategory ? picture.subsubcategory : activity.subsubcategory;
                                pic.city = picture.city ? picture.city : activity.city;
                                pic.country = picture.country ? picture.country : activity.country;
                                pic.label = picture.label ? picture.label : activity.label;
                                pic.segment_order = picture.segment_order ? segment.order : segment.order;
                                pic.activity_order = picture.activity_order ? activity.order : activity.order;
                                pic.comment = picture.comment ? picture.comment : "";
                                if (picture.priority) {
                                    pictures.splice(counter_pictures, 0, pic);
                                    counter_pictures = counter_pictures + 1;
                                } else {
                                    pictures.push(pic);
                                }
                            });
                        });
                    });
                } else {
                    pictures = pictures.concat(data.pictures_all);
                }
                // Remove duplicates from picture list
                const seen = new Set();
                const pictures_unique = pictures.filter(item => {
                    if (seen.has(item.filepath)) {
                        return false;
                    }
                    seen.add(item.filepath);
                    return true;
                });
                // Create refs to sections
                data.segments.forEach((segment, index) => {
                    this.sectionRefs[segment.order] = createRef();
                });
                // Set data to state
                this.setState({
                    data: data,
                    pictures: pictures_unique
                });
                // Set ownership status to state
                if (data.owner_id == this.state.user_id) {
                    this.setState({
                        owner: true
                    });
                } else {
                    this.setState({
                        owner: false
                    });
                }
                // Update verified status
                var verify_status = await this.verifyData(data, pictures);
                await this.setState({
                    verify_status: verify_status
                });
                // Store data
                setJSONLocalStorage(trip_id + "_tripdata_data", data);
                setJSONLocalStorage(trip_id + "_tripdata_pictures", pictures);
            } else {
                // Set data to state
                this.setState({
                    missingdata: true
                });
                // Track error
                /* var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message); */
            }
            window.scrollTo(0, 0);
            this.props.unsetLoading("trip_loadData");
        } catch (error) {
            /* console.log(error); */
            // Set data to state
            this.setState({
                missingdata: true
            });
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_loadData");
            this.props.unsetLoading("trip_loadData");
        } finally {
            this.props.unsetLoading("trip_loadData");
        }
    }


    async logTripView(user_id, trip_id) {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/tripview", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    trip_id: trip_id,
                    user_id: user_id
                }),
            });
            // Track event
            trackEvent("trip_view", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id });
        } catch (error) {
            // Track event
            this.props.logEvent("Client error", "Trip_logTripView");
        }
    }


    async handleTripUnlock() {
        try {
            this.props.setLoading("trip_handleTripUnlock");
            // Send request
            var response = await fetch(this.props.baseUrl + "/tripunlock", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    trip_id: this.state.trip_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.status) {
                // Reload page
                await this.loadData(this.state.trip_id);
                // Track event
                trackEvent("trip_unlock", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id });
                await this.props.unsetLoading("trip_handleTripUnlock");
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not unlock trip data. Please try again later.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Trip_handleTripUnlock");
                this.props.unsetLoading("trip_handleTripUnlock");
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not unlock trip data. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_handleTripUnlock");
            this.props.unsetLoading("trip_handleTripUnlock");
        } finally {
            this.props.unsetLoading("trip_handleTripUnlock");
        }
    }


    async handleReviewCreate(rating, recommended, title, description, anonymous) {
        try {
            this.props.setLoading("trip_handleReviewCreate");
            if (this.state.data.reviews.some(rev => rev.user_id == this.props.user_id)) {
                // User already has submitted a review
                this.props.setError("Error", "You already submitted a review and cannot submit another review.");
                return false;
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/createtripreview", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: {
                        trip_id: this.state.trip_id,
                        rating: rating,
                        recommended: recommended,
                        title: title,
                        description: description,
                        anonymous: anonymous
                    }
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.status) {
                // Track event
                trackEvent("trip_review", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id, trip_rating: rating });
                // Reload page
                this.unsetPopup();
                await this.loadData(this.state.trip_id);
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not create trip review. Please try again later.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Trip_handleReviewCreate");
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not create trip review. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_handleReviewCreate");
        } finally {
            this.props.unsetLoading("trip_handleReviewCreate");
        }
    }

    async handlePurchase() {
        try {
            // Track event
            trackEvent("trip_purchase", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id });
            // Reload page
            this.unsetPopup();
            await this.loadData(this.state.trip_id);
            await this.props.unsetLoading("trip_handlePurchase");
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Payment error";
            var message = "Could complete payment. Please try again. In case you continue to experience issues, please contact support (support@guidr.net).";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_handlePurchase");
        } finally {
            this.props.unsetLoading("trip_handlePurchase");
        }
    }


    toggleMap() {
        this.setState({
            map_expanded: !this.state.map_expanded,
            map_loaded: true
        })
    }


    setPicture(filepath) {
        this.setState({
            picture: filepath
        });
        this.setPopupPicture();
    }


    setPopup(page, segment = "", activity = "", picture_order = "") {
        this.setState({
            popup: {
                page: page,
                segment: segment,
                activity: activity,
                picture: picture_order
            }
        });
    }


    unsetPopup() {
        this.setState({
            popup: {
                page: "",
                segment: "",
                activity: "",
                picture: ""
            }
        });
    }


    setPopupPicture() {
        this.setState({
            popup_picture: true
        });
    }


    unsetPopupPicture() {
        this.setState({
            popup_picture: false
        });
    }


    setEditing(editing, segment = "", activities_category = "", activity = "", picture = "") {
        var current_state = this.state.editing;
        var history = this.state.editing_history
        history.push(current_state);
        this.setState({
            editing: {
                page: editing,
                segment: segment,
                activities_category: activities_category,
                activity: activity,
                picture: picture
            },
            editing_history: history
        });
    }


    unsetEditing() {
        this.setState({
            editing: {
                page: "",
                segment: "",
                segment_new: "",
                activities_category: "",
                activity: "",
                activity_new: "",
                picture: "",
                delete_picture: null,
                delete_description: null,
                delete_segment: false,
                delete_activity: false
            },
            editing_history: []
        });
    }


    goBackEditing() {
        if (this.state.editing_history.length >= 1) {
            var editing = this.state.editing_history.at(-1);
            this.setState({
                editing: editing,
                editing_history: this.state.editing_history.slice(0, -1)
            });
        }
    }


    calculateAge(birthdayString) {
        const today = new Date();
        const birthDate = new Date(birthdayString);
        return Math.floor((today - birthDate) / (1000 * 60 * 60 * 24 * 365));
    }


    handleFileChangePicture(event) {
        this.setState({
            upload_image_file: event.target.files
        });
    }


    // Upload pictures
    async addPicture() {
        const imageFiles = this.state.upload_image_file;
        if (!imageFiles || imageFiles.length === 0) {
            alert('Please select an image file');
            return;
        }
        try {
            this.setState({ uploading: true });
            var files = Array.from(imageFiles);
            // Iterate through all files
            const uploadPromises = files.map(async (file) => {
                try {
                    // Step 1: Request a pre-signed URL for each file
                    const payload = {
                        file_name: file.name,
                        file_type: file.type
                    };
                    const response = await fetch(this.props.baseUrl + "/createuploadurl", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${getToken()}`
                        },
                        body: JSON.stringify(payload)
                    });
                    // Handle response
                    if (!response.ok) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
                    const jsonResponse = await response.json();
                    if (!jsonResponse.value || !jsonResponse.value.link || !jsonResponse.value.link.url || !jsonResponse.value.link.key) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
                    const url = jsonResponse.value.link.url;
                    const key = jsonResponse.value.link.key;
                    if (!url || !key) {
                        throw new Error(`Invalid pre-signed URL response for ${file.name}`);
                    }
                    // Step 2: Upload file to S3 using the pre-signed URL
                    const uploadResponse = await fetch(url, {
                        method: 'PUT',
                        body: file,
                        headers: { 'Content-Type': file.type }
                    });
                    if (!uploadResponse.ok) throw new Error(`Upload failed for ${file.name}`);
                    // Step 3: Request processing of file
                    const processResponse = await fetch(this.props.baseUrl + "/uploadtrippicture", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${getToken()}`
                        },
                        body: JSON.stringify({
                            file_key: key
                        })
                    });
                    // Prepare response
                    if (!processResponse.ok) throw new Error(`Processing failed for ${file.name}`);
                    const response_data = await processResponse.json();
                    return response_data.value.link;
                } catch (error) {
                    // Track error
                    var name = "Error";
                    var message = "We could not upload at least some of your pictures. This might be because their file size is too large or their format is not supported.";
                    this.props.setError(name, message);
                }
            });
            // Wait for all uploads to complete
            const results = await Promise.all(uploadPromises);
            // Add pictures to state
            var data = this.state.data;
            for (var result of results) {
                if (result && result.length > 0) {
                    data.pictures.push({
                        order: data.pictures.length,
                        filepath: result,
                        label: "",
                        comment: ""
                    });
                }
            }
            this.setState({
                data: data,
                changes: true,
                upload_image_file: null
            });
            // Track event
            /* trackEvent("trip_picture_added", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id }); */
            // Save changes
            this.saveChanges();
            this.setState({ uploading: false });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not upload picture.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addPicture");
            this.setState({ uploading: false });
        }
    }


    async addPictureActivity(segment_order, activities_category, activity_order) {
        const imageFiles = this.state.upload_image_file;
        if (!imageFiles || imageFiles.length === 0) {
            alert('Please select one or more image files');
            return;
        }
        try {
            this.setState({ uploading: true });
            var files = Array.from(imageFiles);

            // Iterate through all files
            const uploadPromises = files.map(async (file) => {
                try {
                    // Step 1: Request a pre-signed URL for each file
                    const payload = {
                        file_name: file.name,
                        file_type: file.type
                    };
                    const response = await fetch(this.props.baseUrl + "/createuploadurl", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${getToken()}`
                        },
                        body: JSON.stringify(payload)
                    });
                    // Handle response
                    if (!response.ok) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
                    const jsonResponse = await response.json();
                    if (!jsonResponse.value || !jsonResponse.value.link || !jsonResponse.value.link.url || !jsonResponse.value.link.key) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
                    const url = jsonResponse.value.link.url;
                    const key = jsonResponse.value.link.key;
                    if (!url || !key) {
                        throw new Error(`Invalid pre-signed URL response for ${file.name}`);
                    }
                    // Step 2: Upload file to S3 using the pre-signed URL
                    const uploadResponse = await fetch(url, {
                        method: 'PUT',
                        body: file,
                        headers: { 'Content-Type': file.type }
                    });
                    if (!uploadResponse.ok) throw new Error(`Upload failed for ${file.name}`);
                    // Step 3: Request processing of file
                    const processResponse = await fetch(this.props.baseUrl + "/uploadtrippicture", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${getToken()}`
                        },
                        body: JSON.stringify({
                            file_key: key
                        })
                    });
                    // Prepare response
                    if (!processResponse.ok) throw new Error(`Processing failed for ${file.name}`);
                    const response_data = await processResponse.json();
                    return response_data.value.link;
                } catch (error) {
                    // Track error
                    var name = "Error";
                    var message = "We could not upload at least some of your pictures. This might be because their file size is too large or their format is not supported.";
                    this.props.setError(name, message);
                }
            });
            // Wait for all uploads to complete
            const results = await Promise.all(uploadPromises);
            // Add pictures to state
            var data = this.state.data;
            data.segments.map((segment) => {
                if (segment.order === segment_order) {
                    segment.activities.map((activity) => {
                        if (activity.order === activity_order) {
                            for (var result of results) {
                                if (result && result.length > 0) {
                                    activity.pictures.push({
                                        order: activity.pictures.length,
                                        filepath: result,
                                        label: "",
                                        comment: ""
                                    });
                                }
                            }
                        }
                    });
                }
            });
            this.setState({
                data: data,
                changes: true,
                upload_image_file: null
            });
            // Track event
            /* trackEvent("trip_activity_picture_added", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id }); */
            // Save changes
            this.saveChanges();
            this.setState({ uploading: false });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not upload picture.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addPictureActivity");
            this.setState({ uploading: false });
        }
    }


    setDeletePicture(picture_id) {
        this.setState({
            delete_picture: picture_id
        });
    }


    deletePicture(picture_id) {
        var data = this.state.data;
        /* if (data.pictures.length <= 2) { */
        if (false) {
            var name = "Error";
            var message = "Your trip needs at least 2 pictures. Please add new pictures before you can delete this one.";
            this.props.setError(name, message);
        } else {
            // Handle trip-level pictures
            data.pictures = data.pictures.filter(picture => picture.picture_id != picture_id);
            // Update order attributes for each picture
            var order = 0;
            data.pictures.forEach((picture) => {
                picture.order = order;
                order = order + 1;
            });
            // Handle activity-level pictures
            data.segments.forEach((segment, si) => {
                segment.activities.forEach((activity, ai) => {
                    activity.pictures = activity.pictures.filter(picture => picture.picture_id != picture_id);
                    // Update order attributes for each picture
                    var order = 0;
                    activity.pictures.forEach((picture) => {
                        picture.order = order;
                        order = order + 1;
                    });
                    console.log(activity.pictures);
                })
            });
            // Update state
            this.setState({
                data: data,
                changes: true,
                delete_picture: null
            });
        }
    }


    deletePictureActivity(segment_order, activities_category, activity_order, picture_id) {
        var data = this.state.data;
        // Iterate through all segments and activities and add picture
        data.segments.forEach((segment, si) => {
            segment.activities.forEach((activity, ai) => {
                activity.pictures = activity.pictures.filter(picture => picture.picture_id != picture_id);
                // Update order attributes for each picture
                var order = 0;
                activity.pictures.forEach((picture) => {
                    picture.order = order;
                    order = order + 1;
                });
                console.log(activity.pictures);
            })
        });
        this.setState({
            data: data,
            changes: true,
            delete_picture: null
        });
    }


    toggleTripCategory(category) {
        try {
            var data = this.state.data;
            var categories = data.category;
            if (categories.includes(category)) {
                if (categories.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 trip category.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = categories.indexOf(category);
                if (index !== -1) {
                    categories.splice(index, 1);
                }
            } else {
                categories.push(category);
            }
            data.category = categories;
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_toggleTripCategory");
        }
    }


    toggleTargetGroup(target) {
        try {
            var data = this.state.data;
            var targets = data.target;
            if (targets.includes(target)) {
                if (targets.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 target group.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = targets.indexOf(target);
                if (index !== -1) {
                    targets.splice(index, 1);
                }
            } else {
                targets.push(target);
            }
            data.target = targets;
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_toggleTargetGroup");
        }
    }


    togglePricingCategory(pricing_new) {
        try {
            var data = this.state.data;
            var pricing = data.pricing ? data.pricing : [];
            data.pricing = [pricing_new];
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_togglePricingCategory");
        }
    }


    toggleTimingCategory(timing) {
        try {
            var data = this.state.data;
            var timings = data.timing;
            if (timings.includes(timing)) {
                if (timings.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 timing group.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = timings.indexOf(timing);
                if (index !== -1) {
                    timings.splice(index, 1);
                }
            } else {
                timings.push(timing);
            }
            data.timing = timings;
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_toggleTimingCategory");
        }
    }


    toggleDurationCategory(duration) {
        try {
            var data = this.state.data;
            var durations = data.duration;
            if (durations.includes(duration)) {
                if (durations.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 duration group.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = durations.indexOf(duration);
                if (index !== -1) {
                    durations.splice(index, 1);
                }
            } else {
                durations.push(duration);
            }
            data.duration = durations;
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_toggleDurationCategory");
        }
    }


    updateTitle(label, value) {
        var data = this.state.data;
        data.title = value;
        this.setState({
            data: data,
            changes: true
        });
    }


    addDescription() {
        try {
            var data = this.state.data;
            data.description.push({
                order: data.description.length,
                label: "",
                content: "",
                public: false
            });
            this.setState({
                data: data,
                changes: true,
                delete_description: null
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addDescription");
        }
    }



    updateDescription(label, value) {
        const parts = label.split("_");
        const i = parts[0];
        const category = parts[1];
        var data = this.state.data;
        if (category === "label") {
            data.description[i].label = value;
        }
        if (category === "content") {
            data.description[i].content = value;
        }
        this.setState({
            data: data,
            changes: true
        });
    }


    setDescriptionSetting(label, value) {
        const parts = label.split("_");
        const i = parts[0];
        const category = parts[1];
        var data = this.state.data;
        if (category === "public") {
            data.description[i].public = value;
        }
        this.setState({
            data: data,
            changes: true
        });
    }


    setDeleteDescription(order) {
        this.setState({
            delete_description: order
        });
    }


    async deleteDescription(order) {
        var data = this.state.data;
        if (data.description.length <= 1) {
            var name = "Error";
            var message = "Your trip needs at least one description. Please add new descriptions before you can delete this one.";
            this.props.setError(name, message);
        } else {
            data.description = await data.description.filter(description => description.order !== order);
            // Update order attributes for each picture
            var order = 0;
            await data.description.forEach((description) => {
                description.order = order;
                order = order + 1;
            });
            await this.setState({
                data: data,
                changes: true,
                delete_description: null
            });
        }
    }


    setDeleteTrip() {
        this.setState({
            delete_trip: true
        });
    }


    async deleteTrip() {
        this.props.setLoading("Trip_deleteTrip");
        if (this.state.delete_trip) {
            var trip_id = this.state.data.trip_id;
            try {
                // Send request
                var response = await fetch(this.props.baseUrl + "/deletetrip", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        trip_id: trip_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data) {
                    // Track event
                    trackEvent("trip_delete", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id });
                    await this.setState({
                        changes: true,
                        delete_trip: false
                    });
                    // Redirect to account page
                    this.props.goToPage("/account");
                    this.props.unsetLoading();
                } else {
                    // Track error
                    var name = "Server error";
                    var message = "Could not delete trip. Please try again later.";
                    this.props.setError(name, message);
                    // Track event
                    this.props.logEvent("Client error", "Trip_deleteTrip");
                }
                window.scrollTo(0, 0);
            } catch (error) {
                // Track error
                var name = "Server error";
                var message = "Could not delete trip. Please try again later.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Trip_deleteTrip");
            } finally {
                this.props.unsetLoading("Trip_deleteTrip");
            }
        }
    }


    updateLink(label, value) {
        const parts = label.split("_");
        const i = parts[0];
        const category = parts[1];
        var data = this.state.data;
        if (category === "label") {
            data.links[i].label = value;
        }
        if (category === "link") {
            data.links[i].link = value;
        }
        this.setState({
            data: data,
            changes: true
        });
    }


    setDeleteLink(order) {
        this.setState({
            delete_link: order
        });
    }


    async deleteLink(order) {
        var data = this.state.data;
        data.links = await data.links.filter(link => link.order !== order);
        // Update order attributes for each link
        var order = 0;
        await data.links.forEach((link) => {
            link.order = order;
            order = order + 1;
        });
        await this.setState({
            data: data,
            changes: true,
            delete_link: null
        });
    }


    addLink() {
        try {
            var data = this.state.data;
            data.links.push({
                order: data.links.length,
                label: "",
                link: ""
            });
            this.setState({
                data: data,
                changes: true,
                delete_link: null
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addLink");
        }
    }


    async updateSegmentLabel(label, value) {
        const parts = label.split("_");
        const i = parts[0];
        const category = parts[1];
        var data = this.state.data;
        data.segments.forEach((segment, index) => {
            if (segment.order == i) {
                segment.title = value;
            }
        });
        await this.setState({
            data: data,
            changes: true
        });
    }


    async updateSegmentContent(label, value) {
        const parts = label.split("_");
        const i = parts[0];
        const category = parts[1];
        var data = this.state.data;
        data.segments.forEach((segment, index) => {
            if (segment.order == i) {
                segment.comment = value;
            }
        });
        await this.setState({
            data: data,
            changes: true
        });
    }


    async handleDragStartSegments(index) {
        await this.setState({ segment_dragging: index });
    };


    async handleDragStartActivities(index) {
        await this.setState({ activity_dragging: index });
    };


    async handleDragStartPictures(index) {
        await this.setState({ picture_dragging: index });
    };


    handleDragEndSegments = () => {
        const dragging = this.state.segment_dragging;
        const dropTarget = this.state.segment_dropTarget;
        const data = this.state.data;
        if (dragging !== null && dropTarget !== null) {
            // Update list and order attributes once dropped
            const updatedList = this.moveItem(data.segments, dragging, dropTarget);
            data.segments = updatedList;
            this.setState({
                data: data,
                segment_dragging: null,
                segment_dropTarget: null,
                changes: true
            });
        }
    };


    handleDragEndActivities() {
        const dragging = this.state.activity_dragging;
        const dropTarget = this.state.activity_dropTarget;
        const data = this.state.data;
        if (dragging !== null && dropTarget !== null) {
            data.segments.map((segment, index) => {
                if (segment.order == this.state.editing.segment) {
                    // Update list and order attributes once dropped
                    const updatedList = this.moveItem(segment["activities"], dragging, dropTarget);
                    segment["activities"] = updatedList;
                    this.setState({
                        data: data,
                        activity_dragging: null,
                        activity_dropTarget: null,
                        changes: true
                    });
                }
            });
        }
    };


    handleDragEndPictures() {
        const dragging = this.state.picture_dragging;
        const dropTarget = this.state.picture_dropTarget;
        const data = this.state.data;
        // Update list and order attributes once dropped
        if (dragging !== null && dropTarget !== null) {
            // Handle picture dragging for overall pictures
            if (this.state.editing.activity === "") {
                const updatedList = this.moveItem(data.pictures, dragging, dropTarget);
                data.pictures = updatedList;
            } else {
                const updatedList = this.moveItem(data.segments.find(s => s.order === this.state.editing.segment).activities.find(a => a.order === this.state.editing.activity).pictures, dragging, dropTarget);
                data.segments.find(s => s.order === this.state.editing.segment).activities.find(a => a.order === this.state.editing.activity).pictures = updatedList;
            }
        }
        this.setState({
            data: data,
            segment_dragging: null,
            segment_dropTarget: null,
            changes: true
        });
    };


    handleDragOverSegments = (index) => {
        const dragging = this.state.segment_dragging;
        if (dragging !== index) {
            this.setState({ segment_dropTarget: index });
        }
    };


    handleDragOverActivities = (index) => {
        const dragging = this.state.activity_dragging;
        if (dragging !== index) {
            this.setState({ activity_dropTarget: index });
        }
    };


    handleDragOverPictures = (index) => {
        const dragging = this.state.picture_dragging;
        if (dragging !== index) {
            this.setState({ picture_dropTarget: index });
        }
    };


    moveItem = (list, oldIndex, newIndex) => {
        const draggedItem = list[oldIndex];
        list.splice(oldIndex, 1);
        list.splice(newIndex, 0, draggedItem);
        list.forEach((item, index) => {
            item.order = index;
        });
        return list;
    };


    addSegment() {
        try {
            var data = this.state.data;
            var segment_order = data.segments.length + 1;
            data.segments.push({
                order: segment_order,
                title: "New segment",
                comment: "New segment",
                activities: [],
                activities_stay: [],
                activities_eat: [],
                activities_do: [],
                activities_see: []
            });
            this.setState({
                data: data,
                changes: true
            });
            this.setEditing("segment", segment_order);
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addSegment");
        }
    }


    setDeleteSegment() {
        this.setState({
            delete_segment: true
        });
    }


    deleteSegment(segment_order) {
        try {
            if (this.state.data.segments.length <= 1) {
                var name = "User error";
                var message = "Cannot delete segment. Your trip needs to include at least one segment.";
                this.props.setError(name, message);
            } else {
                var data = this.state.data;
                data.segments = data.segments.filter(segment => segment.order !== segment_order);
                var order = 0;
                data.segments.forEach((segment) => {
                    segment.order = order;
                    order = order + 1;
                });
                this.setState({
                    data: data,
                    changes: true,
                    delete_segment: false
                });
                this.unsetEditing();
            }
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_deleteSegment");
        }
    }


    async addActivity() {
        try {
            var data = this.state.data;
            var segment_order;
            var activities_category = this.state.editing.activities_category;
            var activity_order;
            await data.segments.map((segment, index) => {
                if (segment.order == this.state.editing.segment) {
                    activity_order = segment["activities"].length + 1;
                    segment_order = segment.order;
                    segment["activities"].push({
                        order: activity_order,
                        label: "",
                        comment: "",
                        country: "",
                        state: "",
                        city: "",
                        address: "",
                        website: "",
                        category: activities_category,
                        subcategory: "",
                        pictures: []
                    });
                }
            });
            await this.setState({
                data: data,
                changes: true
            });
            await this.setEditing("activity", segment_order, activities_category, activity_order);
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_addActivity");
        }
    }

    changeActivityAddressMethod(method) {
        this.setState({
            activity_address_method: method
        });
    }


    setDeleteActivity() {
        this.setState({
            delete_activity: true
        });
    }


    deleteActivity(segment_order, activities_category, activity_order) {
        var data = this.state.data;
        data.segments.forEach((segment) => {
            if (segment.order == segment_order) {
                segment["activities"] = segment["activities"].filter(activity => activity.order !== activity_order);
                var order = 0;
                segment["activities"].forEach((activity) => {
                    activity.order = order;
                    order = order + 1;
                });
            }
        });
        this.setState({
            data: data,
            changes: true,
            delete_activity: false
        });
        this.unsetEditing();
    }


    updateActivity(label, value) {
        try {
            var data = this.state.data;
            data.segments.map((segment, index) => {
                if (segment.order == this.state.editing.segment) {
                    segment["activities"].map((activity, i) => {
                        if (activity.order == this.state.editing.activity) {
                            activity[label] = value;
                        }
                    });
                }
            });
            this.setState({
                data: data,
                changes: true
            });
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_updateActivity");
        }
    }


    updateLocationSearch(label, value) {
        this.setState({
            activity_location_search: value
        });
    }


    async searchLocation() {
        try {
            this.props.setLoading("trip_searchLocation");
            if (this.state.activity_location_search.length < 5) {
                // No string available to search
                this.props.setError("Error", "Please type at least 5 characters to search for a location.");
                return false;
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getgeocodedata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    location: this.state.activity_location_search
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (response.status == 200 && data.address_formatted) {
                // Check if country is set
                if (!(Object.keys(this.state.locations).includes(data.country)) || !data.country) {
                    // Track error
                    var name = "Error";
                    var message = "Could not find the right country. Please add the country by hand.";
                    this.props.setError(name, message);
                } else if ((Object.keys(this.state.locations).includes(data.country))) {
                    // Update fields
                    this.updateActivity("country", data.country);
                }
                // Check if city is set
                if ((Object.keys(this.state.locations).includes(data.country)) && (!(this.state.locations[data.country].includes(data.city)) || !data.city)) {
                    // Track error
                    var name = "Error";
                    var message = "Could not find the right city. Please add the city by hand.";
                    this.props.setError(name, message);
                } else if ((Object.keys(this.state.locations).includes(data.country)) && (this.state.locations[data.country].includes(data.city))) {
                    // Update fields
                    this.updateActivity("city", data.city);
                }
                // Check if address is set
                if (!(data.address_formatted && data.address_formatted.length >= 1)) {
                    // Track error
                    var name = "Error";
                    var message = "Could not find the right address. Please add the address by hand.";
                    this.props.setError(name, message);
                } else if (data.address_formatted && data.address_formatted.length >= 1) {
                    // Update fields
                    this.updateActivity("address", data.address_formatted);
                }
                // Update fields
                this.updateActivity("coordinates_lat", data.coordinates_lat);
                this.updateActivity("coordinates_lng", data.coordinates_lng);
                this.updateActivity("postal_code", data.postal_code);
                this.updateActivity("street_number", data.street_number);
                this.updateActivity("street", data.street);
                this.updateActivity("state", data.state);
                this.updateActivity("state_short", data.state_short);
                this.updateActivity("gmaps_place_id", data.gmaps_place_id);
                this.updateActivity("gmaps_types", data.gmaps_types);
                this.updateLocationSearch("", "");
                this.changeActivityAddressMethod("address");
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not find location. Please provide the address or coordinates by hand.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not search for location. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_searchLocation");
        } finally {
            this.props.unsetLoading("trip_searchLocation");
        }
    }


    setSetting(label, value) {
        var data = this.state.data;
        data.settings[label] = value;
        // Override as needed
        if (label == "paid" && value == false) {
            data.settings.price = false;
        }
        if (label == "public" && value == true) {
            data.settings.paid = false;
        }
        if (label == "paid" && value == true) {
            data.settings.public = false;
        }
        if (label == "price") {
            data.settings.public = false;
            data.settings.paid = true;
        }
        this.setState({
            data: data,
            changes: true
        });
    }


    updatePictureTitle(label, value) {
        // Check if page is set
        if (this.state.editing.page !== "picture_editing") {
            return false;
        }
        var data = this.state.data;
        // Handle overall pictures
        data.pictures.forEach((picture, index) => {
            if (picture.picture_id == this.state.editing.picture) {
                picture.comment = value;
                // Update data
                this.setState({
                    data: data,
                    changes: true
                });
                return true;
            }
        });
        // Handle activity-specific pictures
        data.segments.forEach((s, si) => {
            s.activities.forEach((a, ai) => {
                a.pictures.forEach((picture, pi) => {
                    if (picture.picture_id == this.state.editing.picture) {
                        picture.comment = value;
                        // Update data
                        this.setState({
                            data: data,
                            changes: true
                        });
                        return true;
                    }
                })
            })
        });
        return false;
    }


    updatePicturePriority(label, value) {
        // Check if page is set
        if (this.state.editing.page !== "picture_editing") {
            return false;
        }
        var data = this.state.data;

        // Handle overall pictures
        data.pictures.forEach((picture, index) => {
            if (picture.picture_id == this.state.editing.picture) {
                picture.priority = value == "Show on cover" ? true : false;
                // Update data
                this.setState({
                    data: data,
                    changes: true
                });
                return true;
            }
        });
        // Handle activity-specific pictures
        data.segments.forEach((s, si) => {
            s.activities.forEach((a, ai) => {
                a.pictures.forEach((picture, pi) => {
                    if (picture.picture_id == this.state.editing.picture) {
                        picture.priority = value == "Show on cover" ? true : false;
                        // Update data
                        this.setState({
                            data: data,
                            changes: true
                        });
                        return true;
                    }
                })
            })
        });
        return false;
    }


    updatePictureSegment(label, value) {
        value = value === "None" ? "" : value;
        var editing = this.state.editing;
        editing.segment_new = value;
        if (value === "") {
            editing.activity_new = "";
        }
        this.setState({
            editing: editing
        });
        return true;
    }


    updatePictureActivity(label, value) {
        var editing = this.state.editing;
        var activity_new = value === "None" ? "" : value;
        var data = this.state.data;
        var picture = {};
        // Handle overall pictures
        picture = data.pictures.filter(pic => pic.picture_id == this.state.editing.picture)[0];
        if (picture) {
            data.pictures = data.pictures.filter(pic => pic.picture_id != this.state.editing.picture);
        }
        if (!picture) {
            data.segments.forEach((segment, i_s) => {
                segment.activities.forEach((activity, i_a) => {
                    if (!picture) {
                        picture = activity.pictures.filter(pic => pic.picture_id == this.state.editing.picture)[0];
                        activity.pictures = activity.pictures.filter(pic => pic.picture_id != this.state.editing.picture);
                    }
                });
            });
        }
        // Insert picture in new place
        if (picture) {
            if (activity_new == "") {
                /* picture.order = data.pictures.length; */
                data.pictures.push(picture);
                // Update editing
                editing.segment = "";
                editing.activity = "";
                editing.picture = picture.picture_id;
                data.pictures.forEach((item, index) => {
                    item.order = index;
                });
            } else {
                data.segments.forEach((segment, i_s) => {
                    if (segment.title === this.state.editing.segment_new) {
                        segment.activities.forEach((activity, i_a) => {
                            if (activity.label == activity_new) {
                                picture.order = activity.pictures ? activity.pictures.length : 0;
                                activity.pictures.push(picture);
                                // Update editing
                                editing.segment = segment.order;
                                editing.activity = activity.order;
                                editing.picture = picture.picture_id;
                                activity.pictures.forEach((item, index) => {
                                    item.order = index;
                                });
                            }
                        });
                    }
                });
            }
            // Update state
            this.setState({
                data: data,
                editing: editing,
                changes: true
            });
            return true;
        }
        return false;
    }


    async verifyData(data_in, pictures_in, owner = false) {
        if (!data_in.trip_id) {
            return false;
        }
        const data = data_in;
        var return_value = false;
        /* var return_value = data; */
        var general_message = "Your trip is not yet publicly available: ";
        var general_message_optional = "You can improve your trip: ";
        try {
            // Check if title is set
            if (!data.title || data.title.length < 5 || data.title.length > 200) {
                var name = "Data error";
                var message = "Your trip title needs to be between 5 and 200 characters.";
                /* this.props.setError(name, message);
                return_value = false;
                return return_value; */
                return_value = general_message + message;
                return return_value;
            }

            // Check if description is set
            if (!data.description || data.description.length < 1) {
                var name = "Data error";
                var message = "Your trip needs at least 1 description.";
                /* this.props.setError(name, message);
                return_value = false;
                return return_value; */
                return_value = general_message + message;
                return return_value;
            }

            // Check if category is set
            if (!data.category || data.category.length < 1) {
                var name = "Data error";
                var message = "Your trip needs to have at least 1 category attribute (e.g., adventure, beach, safari).";
                /* this.props.setError(name, message);
                return_value = false;
                return return_value; */
                return_value = general_message + message;
                return return_value;
            }

            // Check if size is set
            if (!data.target || data.target.length < 1) {
                var name = "Data error";
                var message = "Your trip needs to have at least 1 target group (e.g., solo travelers, couples).";
                /* this.props.setError(name, message);
                return_value = false;
                return return_value; */
                return_value = general_message + message;
                return return_value;
            }

            // Check if pictures are set
            if ((!data.pictures_all || data.pictures_all.length < 2) && (!pictures_in || pictures_in.length < 2)) {
                var name = "Data error";
                var message = "Your trip needs to have at least 2 pictures.";
                /* this.props.setError(name, message);
                return_value = false;
                return return_value; */
                return_value = general_message + message;
                return return_value;
            }

            // Check if descriptions are too long
            if (owner) {
                await data.description.map((description, description_index) => {
                    // Check if label is set
                    if (!description.label || description.label == "" || description.label.length > 200) {
                        var name = "Data error";
                        var message = "All descriptions should have a title with proper length. We recommend 5 to 200 characters.";
                        /* this.props.setError(name, message);
                        return_value = false;
                        return return_value; */
                        return_value = general_message_optional + message;
                        return return_value;
                    }

                    // Check if content is set
                    if (!description.content || description.content == "" || description.content.length > 10000) {
                        var name = "Data error";
                        var message = "All descriptions should have enough but not too much content. We recommend 5 to 10,000 characters. " + description.label + " is missing content.";
                        /* this.props.setError(name, message);
                        return_value = false;
                        return return_value; */
                        return_value = general_message_optional + message;
                        return return_value;
                    }
                });
            }

            // Detailed check if data is unlocked
            if (data.unlocked) {
                // Check if segments are set
                if (!data.segments || data.segments.length < 1) {
                    var name = "Data error";
                    var message = "Your trip needs to have at least 1 segment.";
                    /* this.props.setError(name, message);
                    return_value = false;
                    return return_value; */
                    return_value = general_message + message;
                    return return_value;
                }

                // Check if activities are set - iterate through all activities
                await data.segments.map((segment, segment_index) => {

                    // Check if activities are set
                    /* if (!segment["activities"] || segment["activities"].length < 1) {
                        var name = "Data error";
                        var message = "Your trip needs to have at least 1 activity for each segment.";
                        return_value = general_message + message;
                        return return_value;
                    } */

                    if (owner) {
                        segment["activities"].map((activity, activity_index) => {
                            // Check if label is set
                            if (!activity.label || activity.label.length < 5 || activity.label.length > 200) {
                                var name = "Data error";
                                var message = "All activities should have a title with proper length. We recommend 5 to 200 characters.";
                                /* this.props.setError(name, message);
                                return_value = false;
                                return return_value; */
                                return_value = general_message_optional + message;
                                return return_value;
                            }

                            // Check if description is set
                            /* if (!activity.comment || activity.comment.length < 5 || activity.comment.length > 2000) {
                                var name = "Data error";
                                var message = "All activities need to have a description with 5 to 2,000 characters.";
                                return_value = general_message + message;
                                return return_value;
                            }
        */
                            // Check if country is set
                            if (!activity.country || activity.country == "" || activity.country.length > 50) {
                                var name = "Data error";
                                var message = "All activities should have a country. " + activity.label + " is missing a country.";
                                /* this.props.setError(name, message);
                                return_value = false;
                                return return_value; */
                                return_value = general_message_optional + message;
                                return return_value;
                            }

                            // Check if address or website are set
                            if ((!activity.address || activity.address == "") && (!activity.website || activity.website == "") || activity.address.length > 1000 || (activity.website && activity.website.length > 1000)) {
                                var name = "Data error";
                                var message = "All activities should have an address or a website. " + activity.label + " is missing an address or website.";
                                /* this.props.setError(name, message);
                                return_value = false;
                                return return_value; */
                                return_value = general_message_optional + message;
                                return return_value;
                            }

                            // Check if category is set
                            if (!activity.category || activity.category == "" || activity.category.length > 50) {
                                var name = "Data error";
                                var message = "All activities should have a category. " + activity.label + " is missing a category.";
                                /* this.props.setError(name, message);
                                return_value = false;
                                return return_value; */
                                return_value = general_message_optional + message;
                                return return_value;
                            }

                        });
                    }
                });
            }
            return return_value;
        } catch (error) {
            // Track error
            var name = "Website error";
            var message = "Could not verify data completeness. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_verifyData");
            return_value = false;
            return return_value;
        }
    }


    async saveChanges() {
        await this.props.setLoading("trip_saveChanges");
        const validated = this.state.data;
        /* const validated = await this.verifyData(this.state.data, this.state.pictures); */
        if (validated !== false) {
            await this.submitUpdateTripData(validated);
            await this.setState({
                changes: false
            });
            await this.loadData(this.state.trip_id);
        }
        await this.props.unsetLoading("trip_saveChanges");
    }


    async discardChanges() {
        this.props.setLoading("trip_discardChanges");
        await this.loadData(this.state.trip_id);
        await this.setState({
            changes: false
        });
        this.props.unsetLoading("trip_discardChanges");
    }


    async submitUpdateTripData(data) {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/updatetripdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: data,
                    user_id: this.state.user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Track event
                trackEvent("trip_update", { trip_id: this.state.data.trip_id, user_id_action: this.props.user_id });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not update trip data. Please try again later.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Trip_submitUpdateTripData");
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not update trip data. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trip_submitUpdateTripData");
        }
    }


    selectMapMarker(value) {
        this.setState({ activity_selected: value });
    }


    render() {

        var reviews_average = null;
        var reviews_1 = null;
        var reviews_2 = null;
        var reviews_3 = null;
        var reviews_4 = null;
        var reviews_5 = null;
        if (this.state.data.reviews && this.state.data.reviews.length >= 1) {
            reviews_average = this.state.data.reviews.reduce((sum, current) => sum + parseInt(current.rating), 0) / this.state.data.reviews.length;
            reviews_average = reviews_average.toFixed(1);

            reviews_1 = (this.state.data.reviews.filter(review => review.rating == 1).length / this.state.data.reviews.length) * 100;
            reviews_2 = (this.state.data.reviews.filter(review => review.rating == 2).length / this.state.data.reviews.length) * 100;
            reviews_3 = (this.state.data.reviews.filter(review => review.rating == 3).length / this.state.data.reviews.length) * 100;
            reviews_4 = (this.state.data.reviews.filter(review => review.rating == 4).length / this.state.data.reviews.length) * 100;
            reviews_5 = (this.state.data.reviews.filter(review => review.rating == 5).length / this.state.data.reviews.length) * 100;
        }

        var allPictures = []
        allPictures = [
            ...(this.state.data.pictures ?? []),
            ...(this.state.data.segments ?? []).flatMap(seg =>
                (seg.activities ?? []).flatMap(act => act.pictures ?? [])
            ),
        ];
        if (allPictures.length < 1) {
            allPictures = this.state.pictures.length > 1 ? this.state.pictures : [];
        }

        return (
            <div className="content-container">

                {(this.state.data.trip_id && this.state.data.title) &&
                    <Helmet>
                        {/* Add the breadcrumb schema as JSON-LD */}
                        <script type="application/ld+json">
                            {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Search itineraries",
                                    "item": "https://guidr.net/trips"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 3,
                                    "name": "${this.state.data.title}",
                                    "item": "https://guidr.net/trip/${this.state.data.trip_id}"
                                }
                                ]
                            }
                            `}
                        </script>
                        <title>{this.state.data.title + " | Guidr itinerary"}</title>
                    </Helmet>
                }

                {((this.state.missingdata || this.state.verify_status) && !this.state.owner) &&
                    <MissingPage />
                }

                {((!this.state.missingdata && !this.state.verify_status) || this.state.owner) &&
                    <div className={"content-wrapper--wide trip-wrapper" + (this.state.map_expanded ? " trip-wrapper--expanded" : "")}>
                        <div className="trip__content">

                            {this.state.data.trip_id &&
                                <div className="trip__section">

                                    {this.state.login && this.state.owner && this.state.data.trip_id && this.state.verify_status &&
                                        <div className="trip__element trip__element__status text-color-grey">
                                            {this.state.verify_status}
                                        </div>
                                    }

                                    <div className="trip__element trip__element__headerbox">
                                        <div className="trip__element__headerbox__infobox">
                                            {(this.state.data.settings.paid && this.state.data.settings.price && this.state.data.settings.price > 0 && (!this.state.data.unlocked || this.state.owner === true)) &&
                                                <div className="trip__element__headerbox__infobox__price text-subtitle text-bold">
                                                    {format_price(parseInt(this.state.data.settings.price))}
                                                </div>
                                            }
                                            {/* {(this.state.data.settings.paid && this.state.data.settings.price && this.state.data.settings.price > 0 && this.state.data.unlocked) &&
                                                <div className="trip__element__headerbox__infobox__price text-subtitle text-bold text-color-grey">
                                                    {"Purchased"}
                                                </div>
                                            } */}
                                            {!(this.state.data.settings.paid && this.state.data.settings.price && this.state.data.settings.price > 0) &&
                                                <div className="trip__element__headerbox__infobox__price text-subtitle text-bold">
                                                    Free
                                                </div>
                                            }
                                            {!this.state.data.settings.paid && reviews_average &&
                                                <div className="trip__element__headerbox__infobox__spacing">
                                                    {"|"}
                                                </div>
                                            }
                                            {reviews_average &&
                                                <div className="trip__element__headerbox__infobox__reviews">
                                                    <IconStar className="trip__element__headerbox__infobox__reviews__icon" />
                                                    <div className="trip__element__headerbox__infobox__reviews__rating">
                                                        {reviews_average}
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        {this.state.loaded &&
                                            <div className="trip__element__headerbox__actionbox">
                                                {this.state.data.unlocked &&
                                                    <div onClick={this.toggleMap} className={"trip__element__headerbox__actionbox__button trip__element__headerbox__actionbox__button--map button" + (this.state.map_expanded ? " button-primary" : " button-primary-light")}>
                                                        Toggle map
                                                    </div>
                                                }
                                                {this.state.login && this.state.owner === true && this.state.data.trip_id &&
                                                    <div onClick={() => this.setEditing("qrcode")} className="trip__element__headerbox__actionbox__button button button-primary-light">
                                                        QR code
                                                    </div>
                                                }
                                                {this.state.login && this.state.owner === false && this.state.data.trip_id && !this.state.data.unlocked && !this.state.data.settings.paid && !this.state.data.settings.price &&
                                                    <div onClick={this.handleTripUnlock} className="trip__element__headerbox__actionbox__button button button-primary">
                                                        Unlock
                                                    </div>
                                                }
                                                {this.state.login && this.state.owner === false && this.state.data.trip_id && !this.state.data.unlocked && this.state.data.settings.paid && this.state.data.settings.price && this.state.data.settings.price > 0 &&
                                                    <div onClick={() => this.setPopup("purchase")} className="trip__element__headerbox__actionbox__button button button-primary">
                                                        Purchase
                                                    </div>
                                                }
                                                {/* Add review button if user is logged in, trip data is loaded, user has unlocked this trip, and user has not reviewed yet */}
                                                {this.state.login && this.state.owner === false && this.state.data.trip_id && this.state.data.unlocked && !this.state.data.reviews.some(rev => rev.user_id == this.props.user_id) &&
                                                    <div onClick={() => this.setPopup("review")} className="trip__element__headerbox__actionbox__button button button-primary">
                                                        Review
                                                    </div>
                                                }
                                                {this.state.login && this.state.owner === true && this.state.data.trip_id &&
                                                    <div onClick={() => this.setEditing("settings")} className="trip__element__headerbox__actionbox__button button button-primary">
                                                        Settings
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>

                                    <div className="trip__element">
                                        {allPictures.length >= 0 &&
                                            <PictureCarousel
                                                data={allPictures}
                                                target={this.state.data.target}
                                                setPopup={this.setPopup.bind(this)}
                                                setPicture={this.setPicture.bind(this)}
                                            />
                                        }
                                        {/* {this.state.pictures.length >= 0 &&
                                            <PictureCarousel
                                                data={this.state.pictures}
                                                target={this.state.data.target}
                                                setPopup={this.setPopup.bind(this)}
                                                setPicture={this.setPicture.bind(this)}
                                            />
                                        } */}

                                        {this.state.owner && this.state.data.trip_id &&
                                            <div className="trip__element__edit-shape"></div>
                                        }
                                        {this.state.owner && this.state.data.trip_id &&
                                            <IconEdit onClick={() => this.setEditing("pictures")} className="trip__element__edit-icon" />
                                        }

                                    </div>
                                </div>
                            }

                            {this.state.data.trip_id &&
                                <div className="trip__section">
                                    <div className="trip__element trip__labelbar">
                                        {this.state.data.collection.slice(0, 10).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?collection=" + element} key={i} className="trip__label trip__label--dark">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.target.slice(0, 4).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?target=" + element} key={i} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.category.slice(0, 4).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?category=" + element} key={i + 100} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.pricing.slice(0, 2).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?pricing=" + element} key={i + 200} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.timing.slice(0, 4).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?timing=" + element} key={i + 300} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.duration.slice(0, 4).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?duration=" + element} key={i + 600} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.countries.slice(0, 2).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?country=" + element} key={i + 400} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}
                                        {this.state.data.cities.slice(0, 2).map((element, i) => (
                                            ((element && element != "") &&
                                                <Link to={"/trips?city=" + element} key={i + 500} className="trip__label">
                                                    {element}
                                                </Link>
                                            )
                                        ))}

                                        {this.state.owner && this.state.data.trip_id &&
                                            <div className="trip__element__edit-shape"></div>
                                        }
                                        {this.state.owner && this.state.data.trip_id &&
                                            <IconEdit onClick={() => this.setEditing("labels")} className="trip__element__edit-icon" />
                                        }

                                    </div>
                                    <h1 className="trip__element trip__element--title trip__title text-title">
                                        {this.state.data.title != "" ? this.state.data.title : "Title"}

                                        {this.state.owner && this.state.data.trip_id &&
                                            <div className="trip__element__edit-shape"></div>
                                        }
                                        {this.state.owner && this.state.data.trip_id &&
                                            <IconEdit onClick={() => this.setEditing("title")} className="trip__element__edit-icon" />
                                        }
                                    </h1>
                                </div>
                            }

                            {this.state.data.trip_id &&
                                <div className="trip__section">
                                    {this.state.data.description.map((d, i) => (
                                        (this.state.data.unlocked || d.public) && (
                                            <div key={i} className="trip__element trip__description-container">
                                                {d.label.length >= 1 &&
                                                    <div className="trip__description__label text-subtitle">
                                                        {d.label}
                                                    </div>
                                                }
                                                {d.label.length < 1 &&
                                                    <div className="trip__description__label text-subtitle text-italic">
                                                        Add a title
                                                    </div>
                                                }
                                                <div className="trip__description__textbox">
                                                    {d.content}
                                                </div>
                                            </div>
                                        )
                                    ))}

                                    {this.state.data.description.length < 1 &&
                                        <div className="trip__element trip__description-container text-italic">
                                            Add your description here
                                        </div>
                                    }

                                    {this.state.owner && this.state.data.trip_id &&
                                        <div className="trip__section__edit-shape"></div>
                                    }
                                    {this.state.owner && this.state.data.trip_id &&
                                        <IconEdit onClick={() => this.setEditing("description")} className="trip__section__edit-icon" />
                                    }

                                </div>
                            }

                            {this.state.data.trip_id && this.state.data.unlocked && this.state.data.links.length >= 1 &&
                                <div className="trip__section">
                                    {this.state.data.links && this.state.data.links.length >= 0 &&
                                        <div className="trip__element text-subtitle">
                                            Links
                                        </div>
                                    }
                                    {this.state.data.links && this.state.data.links.map((d, i) => (
                                        <div key={i} className="trip__element trip__link-container">
                                            {d.label.length >= 1 &&
                                                <div className="trip__link__label text-bold">
                                                    {d.label}
                                                </div>
                                            }
                                            {d.label.length < 1 &&
                                                <div className="trip__link__label text-subtitle text-italic">
                                                    Add a link
                                                </div>
                                            }
                                            <a target="_blank" rel="noopener noreferrer" href={d.link} className="trip__link__textbox">
                                                {d.link}
                                            </a>
                                        </div>
                                    ))}

                                    {this.state.owner && this.state.data.trip_id && this.state.data.links && this.state.data.links.length < 1 &&
                                        <div className="trip__element trip__description-container text-italic">
                                            Add your links here
                                        </div>
                                    }

                                    {this.state.owner && this.state.data.trip_id &&
                                        <div className="trip__section__edit-shape"></div>
                                    }
                                    {this.state.owner && this.state.data.trip_id &&
                                        <IconEdit onClick={() => this.setEditing("links")} className="trip__section__edit-icon" />
                                    }

                                </div>
                            }

                            {(this.state.data.trip_id && this.state.data.owner.username) &&
                                <div className="trip__section trip__owner-wrapper">
                                    <div className="trip__owner__picture">
                                        {this.state.data.owner.picture && this.state.data.owner.picture.length > 0 &&
                                            <img src={this.state.data.owner.picture} alt={this.state.data.owner.name ? this.state.data.owner.name : ""} className="trip__owner__picture-inner" />
                                        }
                                        {(!this.state.data.owner.picture || this.state.data.owner.picture.length <= 0) &&
                                            <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/users/male.webp"} alt={this.state.data.owner.name ? this.state.data.owner.name : ""} className="trip__owner__picture-inner" />
                                        }
                                    </div>
                                    <div className="trip__owner__content">
                                        <Link to={"/u/" + this.state.data.owner.username} className="trip__owner__element text-bold">
                                            {this.state.data.owner.username}
                                        </Link>
                                        <div className="trip__owner__element text-color-grey">
                                            {this.state.data.owner.name &&
                                                <div className="trip__owner__element__span">
                                                    {this.state.data.owner.name}
                                                    {(this.state.data.owner.account_type && this.state.data.owner.account_type != "") ? ", " + this.state.data.owner.account_type : ""}
                                                </div>
                                            }
                                            {this.state.data.owner.birthday &&
                                                <div className="trip__owner__element__span">
                                                    {this.calculateAge(this.state.data.owner.birthday)}
                                                </div>
                                            }
                                            {this.state.data.owner.hometown &&
                                                <div className="trip__owner__element__span">
                                                    {this.state.data.owner.hometown}
                                                </div>
                                            }
                                            {this.state.data.owner.country &&
                                                <div className="trip__owner__element__span">
                                                    {this.state.data.owner.country}
                                                </div>
                                            }
                                        </div>


                                        {this.state.data.owner.badges && this.state.data.owner.badges.length >= 1 &&
                                            <div className="trip__owner__element trip__owner__badges-container">
                                                {this.state.data.owner.badges.map((badge, index) => (
                                                    <div key={index} className="trip__owner__badges__badge">
                                                        <img
                                                            src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/badges/" + badge + ".png"}
                                                            alt={badge}
                                                            className={"trip__owner__badges__badge-inner"}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                        <div className="trip__owner__element">
                                            {this.state.data.owner.bio_description}
                                        </div>
                                    </div>
                                </div>
                            }


                            {(!this.state.data.unlocked && this.state.data.trip_id) &&
                                <div className="trip__section">
                                    {this.state.login &&
                                        <div className="trip__segment-container">
                                            {!(this.state.data.trip_id && this.state.data.segments.length >= 1) &&
                                                <div className="trip__element trip__segment__label text-subtitle text-italic">
                                                    <span>Interested in this trip? Unlock it to see the full itinerary with </span>
                                                    <span className={"text-bold text-color-primary"}>{this.state.data.activities_count} activities</span>
                                                    <span>.</span>
                                                </div>
                                            }
                                            {(this.state.data.trip_id && this.state.data.segments.length >= 1) &&
                                                <div className="trip__element trip__segment__label text-subtitle text-italic">
                                                    <span>Interested in this trip? Unlock it to see </span>
                                                    <span className={"text-bold text-color-primary"}>additional details</span>
                                                    <span>, like descriptions, addresses, websites, and reviews.</span>
                                                </div>
                                            }
                                            {this.state.login && this.state.owner === false && this.state.data.trip_id && !this.state.data.unlocked && !this.state.data.settings.paid && !this.state.data.settings.price &&
                                                <div className="trip__element">
                                                    <div onClick={this.handleTripUnlock} className="button button-primary">
                                                        Unlock this trip
                                                    </div>
                                                </div>
                                            }
                                            {this.state.login && this.state.owner === false && this.state.data.trip_id && !this.state.data.unlocked && this.state.data.settings.paid && this.state.data.settings.price && this.state.data.settings.price > 0 &&
                                                <div className="trip__element">
                                                    <div onClick={() => this.setPopup("purchase")} className="button button-primary">
                                                        Purchase this trip
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {!this.state.login &&
                                        <div className="trip__segment-container">
                                            {!(this.state.data.trip_id && this.state.data.segments.length >= 1) &&
                                                <div className="trip__element trip__segment__label text-subtitle">
                                                    <span>Interested in this trip? Log in or sign up to see the full itinerary with </span>
                                                    <span className={"text-bold text-color-primary"}>{this.state.data.activities_count} activities</span>
                                                    <span>.</span>
                                                </div>
                                            }
                                            {(this.state.data.trip_id && this.state.data.segments.length >= 1) &&
                                                <div className="trip__element trip__segment__label text-subtitle">
                                                    <span>Interested in this trip? Log in or sign up to see </span>
                                                    <span className={"text-bold text-color-primary"}>additional details</span>
                                                    <span>, like descriptions, addresses, websites, and reviews.</span>
                                                </div>
                                            }
                                            <div className="trip__element trip__element__actionbox">
                                                <Link to={(this.props.location.pathname ? "/login?redirect=" + encodeURIComponent(this.props.location.pathname + this.props.location.search) : "/login")} className=" trip__element__actionbox__button button button-primary">
                                                    Log in
                                                </Link>
                                                <Link to={(this.props.location.pathname ? "/signup?redirect=" + encodeURIComponent(this.props.location.pathname + this.props.location.search) : "/signup")} className="trip__element__actionbox__button button button-primary-light">
                                                    Sign up
                                                </Link>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }


                            {(this.state.data.unlocked) &&
                                (this.state.data.trip_id && this.state.data.segments.length < 1) &&
                                <div className="trip__section">

                                    <div className="trip__segment-container">
                                        <div className="trip__element trip__segment__label text-title text-italic">
                                            Add the first segment

                                            {this.state.owner && this.state.data.trip_id &&
                                                <div className="trip__element__edit-shape"></div>
                                            }
                                            {this.state.owner && this.state.data.trip_id &&
                                                <IconEdit onClick={() => this.setEditing("segments")} className="trip__element__edit-icon" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }


                            {(this.state.data.unlocked || (this.state.data.trip_id && this.state.data.segments.length >= 1)) &&
                                (this.state.data.trip_id && this.state.data.segments.length >= 1) &&
                                <div className="trip__section">
                                    {this.state.data.segments.map((segment, i) => (
                                        <div key={i} data-index={segment.order} ref={this.sectionRefs[segment.order]} className="trip__segment-container">
                                            <div className="trip__element trip__segment__label text-title">
                                                {segment.title}

                                                {this.state.owner && this.state.data.trip_id &&
                                                    <div className="trip__element__edit-shape"></div>
                                                }
                                                {this.state.owner && this.state.data.trip_id &&
                                                    <IconEdit onClick={() => this.setEditing("segments")} className="trip__element__edit-icon" />
                                                }

                                            </div>
                                            <div className="trip__element trip__segment__textbox">
                                                {segment.comment}
                                            </div>
                                            {Object.keys(this.state.activity_categories).map((activity_category, index) => (
                                                <div key={index} className="trip__element">
                                                    {segment.activities && (segment.activities.filter(activity => activity.category === activity_category).length >= 1 || this.state.owner) &&
                                                        <div className="trip__element">
                                                            <div className="trip__segment__subtitle text-subtitle">
                                                                {activity_category === "Stay" ? "Where to stay?" : ""}
                                                                {activity_category === "Eat" ? "Where to eat?" : ""}
                                                                {activity_category === "Do" ? "What to do?" : ""}
                                                                {activity_category === "See" ? "What to see?" : ""}
                                                            </div>
                                                            {this.state.owner && this.state.data.trip_id &&
                                                                <div className="trip__element__edit-shape"></div>
                                                            }
                                                            {this.state.owner && this.state.data.trip_id &&
                                                                <IconEdit onClick={() => this.setEditing("activities", segment.order, activity_category)} className="trip__element__edit-icon" />
                                                            }
                                                        </div>
                                                    }
                                                    {segment.activities && segment.activities.filter(activity => activity.category === activity_category).length >= 1 &&
                                                        <div className="trip__element trip__segment__activitylist">
                                                            {segment.activities.filter(activity => activity.category === activity_category).map((activity, j) => (
                                                                <Activity
                                                                    key={j}
                                                                    data={activity}
                                                                    setEditing={this.setEditing}
                                                                    owner={this.state.owner}
                                                                    unlocked={this.state.data.unlocked}
                                                                    segment_order={segment.order}
                                                                    segment_key={i}
                                                                    activity_key={j}
                                                                    activities_category={activity_category}
                                                                    selectMapMarker={this.selectMapMarker.bind(this)}
                                                                    activity_selected={this.state.activity_selected}
                                                                    setPopup={this.setPopup.bind(this)}
                                                                />
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            }

                            {this.state.data.unlocked &&
                                (this.state.data.trip_id && this.state.data.reviews.length >= 1) &&
                                <div className="trip__section">
                                    <div className="trip__element text-title">
                                        Traveler reviews
                                    </div>
                                    <div className="trip__element">
                                        {reviews_average &&
                                            <div className="trip__reviews__headline">
                                                <IconStar className="trip__reviews__headline__icon" />
                                                <div className="text-bold">
                                                    {reviews_average + " out of 5"}
                                                </div>
                                            </div>
                                        }
                                        <div className="trip__reviews__subline">
                                            {reviews_5 >= 0 &&
                                                <div className="trip__reviews__subline__link">
                                                    {reviews_5 + "% 5-star"}
                                                </div>
                                            }
                                            <div className="trip__reviews__subline__spacing">
                                                |
                                            </div>
                                            {reviews_4 >= 0 &&
                                                <div className="trip__reviews__subline__link">
                                                    {reviews_4 + "% 4-star"}
                                                </div>
                                            }
                                            <div className="trip__reviews__subline__spacing">
                                                |
                                            </div>
                                            {reviews_3 >= 0 &&
                                                <div className="trip__reviews__subline__link">
                                                    {reviews_3 + "% 3-star"}
                                                </div>
                                            }
                                            <div className="trip__reviews__subline__spacing">
                                                |
                                            </div>
                                            {reviews_2 >= 0 &&
                                                <div className="trip__reviews__subline__link">
                                                    {reviews_2 + "% 2-star"}
                                                </div>
                                            }
                                            <div className="trip__reviews__subline__spacing">
                                                |
                                            </div>
                                            {reviews_1 >= 0 &&
                                                <div className="trip__reviews__subline__link">
                                                    {reviews_1 + "% 1-star"}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="trip__reviews__list-container">
                                        {this.state.data.reviews.map((review, i) => (
                                            <Review
                                                key={i}
                                                index={i}
                                                data={review}
                                            />
                                        ))}
                                    </div>
                                </div>
                            }
                            <div className="trip__section">
                                <div className="trip__element text-color-grey text-small">
                                    {this.state.data.created ? "Created in " + format_month_year(this.state.data.created) + " | " : ""}
                                    {(this.state.data.updated && this.state.data.updated.length >= 1) ? "Last updated in " + format_month_year(this.state.data.updated[this.state.data.updated.length - 1]) : ""}
                                </div>
                            </div>

                        </div>


                        {this.state.data.trip_id &&
                            <div className={"trip__sidebar-container" + (this.state.map_expanded ? "" : " trip__sidebar-container--hidden")}>
                                <div className="trip__sidebar">
                                    {this.state.map_loaded &&
                                        <div className="trip__map">
                                            <TripMap
                                                apiKey="AIzaSyBJ6Rx7IshzXH89xxY5zEZ17lsozTjwgy8"
                                                data={this.state.data.unlocked ? this.state.data.segments : []}
                                                selectMapMarker={this.selectMapMarker.bind(this)}
                                                activity_selected={this.state.activity_selected}
                                                toggleMap={this.toggleMap}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                    </div>
                }


                {/* <div className="trip__collapse-container">
                    <div className={"trip__collapse__button" + (this.state.map_expanded ? " trip__collapse__button--expanded" : "")}>
                        <IconArrow onClick={this.toggleMap} className={"trip__collapse__button-inner"} />
                    </div>
                </div> */}


                {/* Popups for deep dives */}
                {this.state.data.trip_id && (this.state.popup.page !== "" || this.state.popup_picture) &&
                    <div className="trip__overlay"></div>
                }

                {/* Show pictures */}
                {this.state.data.trip_id && this.state.popup.page === "pictures" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetPopup} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__element trip__popup__headerbox">
                                {this.state.popup.page === "pictures" &&
                                    <span onClick={() => this.setPopup("pictures")} className={"trip__popup__headerbox__link text-subtitle"}>
                                        Trip pictures
                                    </span>
                                }
                                {this.state.popup.page === "pictures" && this.state.popup.segment !== "" &&
                                    <span className={"trip__popup__headerbox__spacing text-subtitle"}>
                                        {">"}
                                    </span>
                                }
                                {this.state.popup.page === "pictures" && this.state.popup.segment !== "" &&
                                    <span onClick={() => this.setPopup("pictures", this.state.popup.segment)} className={"trip__popup__headerbox__link text-subtitle"}>
                                        {this.state.data.segments.find(s => s.order === this.state.popup.segment).title}
                                    </span>
                                }

                                {this.state.popup.page === "pictures" && this.state.popup.segment !== "" && this.state.popup.activity !== "" &&
                                    <span className={"trip__popup__headerbox__spacing text-subtitle"}>
                                        {">"}
                                    </span>
                                }
                                {this.state.popup.page === "pictures" && this.state.popup.segment !== "" && this.state.popup.activity !== "" &&
                                    (this.state.data.segments[this.state.popup.segment] &&
                                        (this.state.data.segments.find(s => s.order === this.state.popup.segment).activities[this.state.popup.activity] &&
                                            <span onClick={() => this.setPopup("pictures", this.state.popup.segment, this.state.popup.activity)} className={"trip__popup__headerbox__link text-subtitle"}>
                                                {this.state.data.segments.find(s => s.order === this.state.popup.segment).activities.find(a => a.order === this.state.popup.activity).label}
                                            </span>
                                        )
                                    )
                                }

                            </div>

                            {this.state.popup.page === "pictures" && this.state.popup.segment === "" && this.state.popup.activity === "" &&
                                <div className="trip__popup__section">
                                    {this.state.owner &&
                                        <div className="trip__popup__element trip__popup__picturelist-container trip__popup__picturelist-container--wide">
                                            {this.state.data.pictures.map((picture, i) => (
                                                (typeof picture.filepath === 'string' && picture.filepath.length >= 1 && picture.type != "activity" &&
                                                    <div key={i} className="trip__popup__picture" >
                                                        {picture.filepath.endsWith(".mp4") ||
                                                            picture.filepath.endsWith(".mov") ||
                                                            picture.filepath.endsWith(".avi") ? (
                                                            <video
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                                playsInline
                                                                controls
                                                                muted
                                                                loop
                                                                preload="auto"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    }
                                    {!this.state.owner &&
                                        <div className="trip__popup__element trip__popup__picturelist-container trip__popup__picturelist-container--wide">
                                            {this.state.data.pictures_all.map((picture, i) => (
                                                (typeof picture.filepath === 'string' && picture.filepath.length >= 1 && picture.type != "activity" &&
                                                    <div key={i} className="trip__popup__picture" >
                                                        {picture.filepath.endsWith(".mp4") ||
                                                            picture.filepath.endsWith(".mov") ||
                                                            picture.filepath.endsWith(".avi") ? (
                                                            <video
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                                playsInline
                                                                controls
                                                                muted
                                                                loop
                                                                preload="auto"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    }
                                </div>
                            }

                            {/* For each segment */}
                            {this.state.data.segments.map((segment, i) => (
                                (segment.order == this.state.popup.segment || this.state.popup.segment === "") &&
                                <div key={i} className="trip__popup__section">
                                    {this.state.popup.segment === "" && this.state.popup.activity === "" &&
                                        <div className="trip__popup__element trip__popup__headerbox">
                                            <span onClick={() => this.setPopup("pictures", segment.order)} className="trip__popup__headerbox__link text-subtitle">
                                                {segment.title}
                                            </span>
                                        </div>
                                    }
                                    <div className="trip__popup__element trip__popup__picturelist-container">
                                        {/* For each activity and picture */}
                                        {segment.activities.map((activity, i2) => (
                                            (activity.order == this.state.popup.activity || this.state.popup.activity === "") && activity.pictures.map((picture, i3) => (
                                                (typeof picture.filepath === 'string' && picture.filepath.length >= 1 &&
                                                    <div key={i3} className="trip__popup__picture">
                                                        {picture.filepath.endsWith(".mp4") ||
                                                            picture.filepath.endsWith(".mov") ||
                                                            picture.filepath.endsWith(".avi") ? (
                                                            <video
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                                playsInline
                                                                controls
                                                                muted
                                                                loop
                                                                preload="auto"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => this.setPicture(picture.filepath)}
                                                                src={picture.filepath}
                                                                alt={picture.label}
                                                                className={"trip__popup__picture-inner"}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            ))
                                        ))}
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                }

                {/* Show a single picture */}
                {this.state.data.trip_id && this.state.popup_picture && allPictures.length >= 1 &&
                    <TripPicture
                        data={allPictures}
                        picture={this.state.picture}
                        unsetPopup={this.unsetPopupPicture}
                        setError={this.props.setError}
                        setLoading={this.props.setLoading}
                    />
                }

                {/* Show a single picture */}
                {/* {this.state.data.trip_id && this.state.popup.page === "picture" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetPopup} className="trip__popup__close" />
                            </div>

                        </div>
                    </div>
                } */}

                {/* Purchase trip */}
                {(this.state.data.trip_id && this.state.popup.page === "purchase" && this.state.user_id && this.state.data.settings && this.state.data.settings.price && this.state.data.settings.price > 0) &&
                    <Purchase
                        baseUrl={this.props.baseUrl}
                        apiTimeout={this.props.apiTimeout}
                        handlePurchase={this.handlePurchase}
                        title={this.state.data.title}
                        unsetPopup={this.unsetPopup}
                        setError={this.props.setError}
                        setLoading={this.props.setLoading}
                        logEvent={this.props.logEvent}
                        unsetLoading={this.props.unsetLoading}
                        trip_id={this.state.data.trip_id}
                        trip_title={this.state.data.title}
                        user_id={this.state.user_id}
                        owner_name={this.state.data.owner.username}
                        owner_id={this.state.data.owner.user_id}
                        amount={this.state.data.settings.price || 0.00}
                        items={[
                            {
                                label: this.state.data.title,
                                amount: this.state.data.settings.price || 0.00,
                                taxes: 0.00,
                                quantity: 1
                            }
                        ]}
                    />
                }

                {/* Write a review */}
                {this.state.data.trip_id && this.state.popup.page === "review" &&
                    <ReviewCreate
                        createReview={this.handleReviewCreate}
                        unsetPopup={this.unsetPopup}
                        setError={this.props.setError}
                        setLoading={this.props.setLoading}
                    />
                }


                {/* Popups for editing */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page !== "" &&
                    <div className="trip__overlay"></div>
                }

                {/* Edit pictures */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "pictures" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__picturelist-container">
                                    {allPictures.map((picture, i) => (
                                        ((typeof picture.filepath === 'string' && picture.filepath.length >= 1) &&
                                            <div
                                                key={i}
                                                draggable
                                                onDragStart={() => this.handleDragStartPictures(picture.order)}
                                                onDragEnd={this.handleDragEndPictures}
                                                onDragOver={() => this.handleDragOverPictures(picture.order)}
                                                className={"trip__popup__picture trip__popup__picture--draggable"}
                                            >
                                                {picture.filepath.endsWith(".mp4") ||
                                                    picture.filepath.endsWith(".mov") ||
                                                    picture.filepath.endsWith(".avi") ? (
                                                    <video
                                                        src={picture.filepath}
                                                        alt={picture.label}
                                                        className={"trip__popup__picture-inner"}
                                                        playsInline
                                                        controls
                                                        muted
                                                        preload="auto"
                                                    />
                                                ) : (
                                                    <img
                                                        src={picture.filepath}
                                                        alt={picture.label}
                                                        className={"trip__popup__picture-inner"}
                                                    />
                                                )}
                                                <div className="trip__popup__picture-overlay">
                                                    <div onClick={() => this.setEditing("picture_editing", "", "", "", picture.picture_id)} className={"trip__popup__picture__icon trip__popup__picture__icon-edit"}>
                                                        <IconEdit className="trip__popup__picture__icon-inner" />
                                                    </div>
                                                    <div onClick={() => this.setDeletePicture(picture.picture_id)} className={"trip__popup__picture__icon trip__popup__picture__icon-delete" + (this.state.delete_picture == picture.picture_id ? " hidden" : "")}>
                                                        <IconDelete className="trip__popup__picture__icon-inner" />
                                                    </div>
                                                    <div onClick={() => this.deletePicture(picture.picture_id)} className={"trip__popup__picture__button text-bold" + (this.state.delete_picture == picture.picture_id ? "" : " hidden")}>
                                                        Delete
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    ))}

                                    <div className="trip__popup__picture">
                                        <div className="trip__popup__picture__add-container">
                                            <IconAdd className="trip__popup__picture__add" />
                                            {!this.state.upload_image_file && !this.state.uploading &&
                                                <input type="file" multiple onChange={this.handleFileChangePicture} className="trip__popup__picture__add-input" />
                                            }
                                            {this.state.upload_image_file && !this.state.uploading &&
                                                <div onClick={this.addPicture} className="trip__popup__picture__add-submit text-bold">
                                                    Upload
                                                </div>
                                            }
                                            {this.state.uploading &&
                                                <div className="trip__popup__picture__add-uploading text-bold">
                                                    Uploading...
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="trip__popup__element text-italic text-color-grey">
                                    Please note that large video files will only be available a few minutes after uploading.
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Edit picture */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "picture_editing" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                                <IconArrow onClick={this.goBackEditing} className="trip__popup__close trip__popup__close--back" />
                            </div>

                            {/* Iterate thtorugh trip-levle pictures */}
                            {this.state.data.pictures.map((picture, i) => (
                                this.state.editing.picture == picture.picture_id && (
                                    <div key={i} className="trip__popup__section">
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Picture title
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputText
                                                    name={"picture_title"}
                                                    label={""}
                                                    default_value={picture.comment}
                                                    setFormValue={this.updatePictureTitle.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Cover picture
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputDropdown
                                                    name={"cover_picture"}
                                                    label={""}
                                                    list={["Show on cover", "Not on cover"]}
                                                    default_value={picture.priority ? "Show on cover" : "Not on cover"}
                                                    setFormValue={this.updatePicturePriority.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Segment
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputDropdown
                                                    name={"picture_segment"}
                                                    label={""}
                                                    list={["None"].concat(this.state.data.segments.map(item => item.title))}
                                                    default_value={"None"}
                                                    setFormValue={this.updatePictureSegment.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Activity
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputDropdown
                                                    name={"picture_activity"}
                                                    label={""}
                                                    list={(this.state.editing.segment_new === "" || this.state.editing.segment_new === "" || !this.state.editing.segment_new) ? ["None"] : this.state.data.segments.filter(segment => segment.title === this.state.editing.segment_new)[0].activities.map(activity => activity.label)}
                                                    default_value={"None"}
                                                    setFormValue={this.updatePictureActivity.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__picture trip__popup__picture--full-height">
                                                {picture.filepath.endsWith(".mp4") ||
                                                    picture.filepath.endsWith(".mov") ||
                                                    picture.filepath.endsWith(".avi") ? (
                                                    <video
                                                        src={picture.filepath}
                                                        alt={picture.label}
                                                        className={"trip__popup__picture-inner"}
                                                        playsInline
                                                        controls
                                                        muted
                                                        preload="auto"
                                                    />
                                                ) : (
                                                    <img
                                                        src={picture.filepath}
                                                        alt={picture.label}
                                                        className={"trip__popup__picture-inner"}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))
                            }

                            {/* Iterate thtorugh activity-levle pictures */}
                            {this.state.data.segments.map((segment, index_s) => (
                                segment.activities.map((activity, index_a) => (
                                    activity.pictures.map((picture, i) => (

                                        this.state.editing.picture == picture.picture_id &&
                                        <div key={i} className="trip__popup__section">
                                            <div className="trip__popup__element">
                                                <div className="trip__popup__element__label text-subtitle">
                                                    Picture title
                                                </div>
                                                <div className="trip__popup__element__content">
                                                    <ForminputText
                                                        name={"picture_title"}
                                                        label={""}
                                                        default_value={picture.comment}
                                                        setFormValue={this.updatePictureTitle.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="trip__popup__element">
                                                <div className="trip__popup__element__label text-subtitle">
                                                    Cover picture
                                                </div>
                                                <div className="trip__popup__element__content">
                                                    <ForminputDropdown
                                                        name={"cover_picture"}
                                                        label={""}
                                                        list={["Show on cover", "Not on cover"]}
                                                        default_value={picture.priority ? "Show on cover" : "Not on cover"}
                                                        setFormValue={this.updatePicturePriority.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="trip__popup__element">
                                                <div className="trip__popup__element__label text-subtitle">
                                                    Segment
                                                </div>
                                                <div className="trip__popup__element__content">
                                                    <ForminputDropdown
                                                        name={"picture_segment"}
                                                        label={""}
                                                        list={["None"].concat(this.state.data.segments.map(item => item.title))}
                                                        default_value={segment.title}
                                                        setFormValue={this.updatePictureSegment.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            </div>

                                            <div className="trip__popup__element">
                                                <div className="trip__popup__element__label text-subtitle">
                                                    Activity
                                                </div>
                                                <div className="trip__popup__element__content">
                                                    <ForminputDropdown
                                                        name={"picture_activity"}
                                                        label={""}
                                                        list={(this.state.editing.segment_new === "" || !this.state.editing.segment_new) ? ["None"] : this.state.data.segments.filter(segment => segment.title === this.state.editing.segment_new)[0].activities.map(activity => activity.label)}
                                                        default_value={activity.label}
                                                        setFormValue={this.updatePictureActivity.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            </div>

                                            <div className="trip__popup__element">
                                                <div className="trip__popup__picture trip__popup__picture--full-height">
                                                    {picture.filepath.endsWith(".mp4") ||
                                                        picture.filepath.endsWith(".mov") ||
                                                        picture.filepath.endsWith(".avi") ? (
                                                        <video
                                                            src={picture.filepath}
                                                            alt={picture.label}
                                                            className={"trip__popup__picture-inner"}
                                                            playsInline
                                                            controls
                                                            muted
                                                            preload="auto"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={picture.filepath}
                                                            alt={picture.label}
                                                            className={"trip__popup__picture-inner"}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    ))
                                ))
                            ))}

                            {/* Buttons to navigate to next or previous picture */}
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__buttonbox">
                                    <button
                                        onClick={() =>
                                            allPictures?.length &&
                                            this.setEditing(
                                                "picture_editing",
                                                "",
                                                "",
                                                "",
                                                allPictures[(allPictures.findIndex(p => p.picture_id == this.state.editing.picture) - 1 + allPictures.length) % allPictures.length]?.picture_id
                                            )
                                        }
                                        className={"button button-primary"}
                                    >
                                        Previous
                                    </button>
                                    <button
                                        onClick={() =>
                                            allPictures?.length &&
                                            this.setEditing(
                                                "picture_editing",
                                                "",
                                                "",
                                                "",
                                                allPictures[(allPictures.findIndex(p => p.picture_id == this.state.editing.picture) + 1) % allPictures.length]?.picture_id
                                            )
                                        }
                                        className={"button button-primary"}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit labels */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "labels" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Trip category
                                    </div>
                                    <div className="trip__popup__element__content trip__labelbar">
                                        {this.state.trip_categories.map((category, i) => (
                                            <div key={i} onClick={() => this.toggleTripCategory(category)} className={"trip__label" + (this.state.data.category.includes(category) ? " trip__label--selected" : " trip__label--unselected")}>
                                                {category}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Target group
                                    </div>
                                    <div className="trip__popup__element__content trip__labelbar">
                                        {this.state.trip_targets.map((target, i) => (
                                            <div key={i} onClick={() => this.toggleTargetGroup(target)} className={"trip__label" + (this.state.data.target.includes(target) ? " trip__label--selected" : " trip__label--unselected")}>
                                                {target}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Pricing
                                    </div>
                                    <div className="trip__popup__element__content trip__labelbar">
                                        {this.state.trip_pricing.map((pricing, i) => (
                                            <div key={i} onClick={() => this.togglePricingCategory(pricing)} className={"trip__label" + (this.state.data.pricing.includes(pricing) ? " trip__label--selected" : " trip__label--unselected")}>
                                                {pricing}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Timing
                                    </div>
                                    <div className="trip__popup__element__content trip__labelbar">
                                        {this.state.trip_timing.map((timing, i) => (
                                            <div key={i} onClick={() => this.toggleTimingCategory(timing)} className={"trip__label" + (this.state.data.timing.includes(timing) ? " trip__label--selected" : " trip__label--unselected")}>
                                                {timing}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Duration
                                    </div>
                                    <div className="trip__popup__element__content trip__labelbar">
                                        {this.state.trip_duration.map((duration, i) => (
                                            <div key={i} onClick={() => this.toggleDurationCategory(duration)} className={"trip__label" + (this.state.data.duration.includes(duration) ? " trip__label--selected" : " trip__label--unselected")}>
                                                {duration}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit title */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "title" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Title
                                    </div>
                                    <div className="trip__popup__element__content">
                                        <ForminputText
                                            name={"title"}
                                            label={""}
                                            default_value={this.state.data.title}
                                            setFormValue={this.updateTitle.bind(this)}
                                            required={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit descriptions */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "description" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            {this.state.data.description.map((d, i) => (
                                <div key={i} className="trip__popup__section trip__popup__description">
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Label
                                        </div>
                                        <div className="trip__popup__element__content">
                                            <ForminputText
                                                name={i + "_label"}
                                                label={""}
                                                default_value={d.label}
                                                setFormValue={this.updateDescription.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Content
                                        </div>
                                        <div className="trip__popup__element__content">
                                            <ForminputTextbox
                                                name={i + "_content"}
                                                label={""}
                                                default_value={d.content}
                                                setFormValue={this.updateDescription.bind(this)}
                                                required={true}
                                            />
                                        </div>

                                        <div className="trip__popup__element__content">
                                            <div className="trip__popup__switch-container">
                                                <div onClick={() => this.setDescriptionSetting(i + "_public", true)} className={"trip__popup__switch__button" + (d.public ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        Always visible
                                                    </div>
                                                </div>
                                                <div onClick={() => this.setDescriptionSetting(i + "_public", false)} className={"trip__popup__switch__button" + (!d.public ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        Only visible when trip is unlocked
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="trip__popup__element__content text-small text-color-grey">
                                            'Always visible' descriptions are helpful for travelers who have not yet unlocked/ purchased your trip itinerary to decide whether they should do so.
                                        </div>

                                    </div>
                                    <div className="trip__popup__element trip__popup__buttonbox">
                                        <button disabled={this.state.delete_description} onClick={() => this.setDeleteDescription(d.order)} className={"button" + (this.state.delete_description == d.order ? " button-inactive" : " button-primary-light")}>
                                            Delete description
                                        </button>
                                        <button disabled={this.state.delete_description != d.order} onClick={() => this.deleteDescription(d.order)} className={"button" + (this.state.delete_description == d.order ? " button-primary" : " button-inactive")}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            ))}
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__addbutton-container">
                                    <div onClick={this.addDescription} className="trip__popup__addbutton">
                                        <IconAdd className="trip__popup__addbutton-inner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit links */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "links" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            {this.state.data.links.map((d, i) => (
                                <div key={i} className="trip__popup__section trip__popup__description">
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Label
                                        </div>
                                        <div className="trip__popup__element__content">
                                            <ForminputText
                                                name={i + "_label"}
                                                label={""}
                                                default_value={d.label}
                                                setFormValue={this.updateLink.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Link
                                        </div>
                                        <div className="trip__popup__element__content">
                                            <ForminputText
                                                name={i + "_link"}
                                                label={""}
                                                default_value={d.link}
                                                setFormValue={this.updateLink.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="trip__popup__element trip__popup__buttonbox">
                                        <button disabled={this.state.delete_link} onClick={() => this.setDeleteLink(d.order)} className={"button" + (this.state.delete_link == d.order ? " button-inactive" : " button-primary-light")}>
                                            Delete link
                                        </button>
                                        <button disabled={this.state.delete_link != d.order} onClick={() => this.deleteLink(d.order)} className={"button" + (this.state.delete_link == d.order ? " button-primary" : " button-inactive")}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            ))}
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__addbutton-container">
                                    <div onClick={this.addLink} className="trip__popup__addbutton">
                                        <IconAdd className="trip__popup__addbutton-inner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Arrange segments */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "segments" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__segmentlist">
                                    {this.state.data.segments.map((segment, i) => (
                                        <div
                                            key={i}
                                            draggable
                                            onDragStart={() => this.handleDragStartSegments(segment.order)}
                                            onDragEnd={this.handleDragEndSegments}
                                            onDragOver={() => this.handleDragOverSegments(segment.order)}
                                            className={"trip__popup__segment" + (this.state.segment_dragging === segment.order ? " trip__popup__segment--dragging" : "")}
                                        >
                                            <div className="trip__popup__element__label text-subtitle">
                                                {segment.title}
                                            </div>
                                            <IconEdit onClick={() => this.setEditing("segment", segment.order)} className="trip__popup__element__edit-icon" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__addbutton-container">
                                    <div onClick={this.addSegment} className="trip__popup__addbutton">
                                        <IconAdd className="trip__popup__addbutton-inner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit specific segment */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "segment" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>

                            {this.state.data.segments.map((segment, i) => (
                                this.state.editing.segment == segment.order &&
                                (
                                    <div key={i} className="trip__popup__section">
                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Label
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputText
                                                    name={segment.order + "_label"}
                                                    label={""}
                                                    default_value={segment.title}
                                                    setFormValue={this.updateSegmentLabel}
                                                    required={true}
                                                    {...this.props}
                                                />
                                            </div>
                                        </div>

                                        <div className="trip__popup__element">
                                            <div className="trip__popup__element__label text-subtitle">
                                                Description
                                            </div>
                                            <div className="trip__popup__element__content">
                                                <ForminputTextbox
                                                    name={segment.order + "_comment"}
                                                    label={""}
                                                    default_value={segment.comment}
                                                    setFormValue={this.updateSegmentContent}
                                                    required={true}
                                                    {...this.props}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}

                            <div className="trip__popup__section trip__popup__buttonbox">
                                <button disabled={this.state.delete_segment} onClick={this.setDeleteSegment} className={"button" + (this.state.delete_segment ? " button-inactive" : " button-primary-light")}>
                                    Delete segment?
                                </button>
                                <button disabled={!this.state.delete_segment} onClick={() => this.deleteSegment(this.state.editing.segment)} className={"button" + (this.state.delete_segment ? " button-primary" : " button-inactive")}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                }


                {/* Arrange activities within a segment */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "activities" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>

                            {this.state.data.segments.map((segment, index) => (
                                segment.order == this.state.editing.segment && (
                                    <div key={index} className="trip__popup__section">
                                        <div className="trip__popup__element trip__popup__segmentlist">

                                            {segment.activities.filter(activity => activity.category === this.state.editing.activities_category).map((activity, i) => (
                                                <div
                                                    key={i}
                                                    draggable
                                                    onDragStart={() => this.handleDragStartActivities(activity.order)}
                                                    onDragEnd={this.handleDragEndActivities}
                                                    onDragOver={() => this.handleDragOverActivities(activity.order)}
                                                    className={"trip__popup__segment" + (this.state.activity_dragging === activity.order ? " trip__popup__segment--dragging" : "")}
                                                >
                                                    <div className="trip__popup__element__label text-subtitle">
                                                        {activity.label}
                                                    </div>
                                                    <IconEdit onClick={() => this.setEditing("activity", segment.order, this.state.editing.activities_category, activity.order)} className="trip__popup__element__edit-icon" />
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                )
                            ))}

                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__addbutton-container">
                                    <div onClick={this.addActivity} className="trip__popup__addbutton">
                                        <IconAdd className="trip__popup__addbutton-inner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit specific activity */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "activity" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>
                            {this.state.data.segments.map((segment, index) => (
                                segment.order == this.state.editing.segment && (
                                    <div key={index} className="">

                                        {segment.activities.map((activity, i) => (
                                            activity.order == this.state.editing.activity && (
                                                <div key={i} className="trip__popup__section">

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Title
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputText
                                                                key={"label"}
                                                                name={"label"}
                                                                label={""}
                                                                default_value={activity.label}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Description
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputTextbox
                                                                key={"comment"}
                                                                name={"comment"}
                                                                label={""}
                                                                default_value={activity.comment}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Category
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputDropdown
                                                                name={"category"}
                                                                label={""}
                                                                list={Object.keys(this.state.activity_categories)}
                                                                default_value={activity.category}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Subcategory
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputDropdown
                                                                name={"subcategory"}
                                                                label={""}
                                                                list={Object.keys(this.state.activity_categories[activity.category])}
                                                                default_value={activity.subcategory}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={true}
                                                            />
                                                        </div>
                                                        {/* (this.state.activity_categories[activity.category][activity.subcategory] && this.state.activity_categories[activity.category][activity.subcategory].length >= 1) &&
                                                            <div className="trip__popup__element__content">
                                                                <ForminputDropdown
                                                                    name={"subsubcategory"}
                                                                    label={""}
                                                                    list={this.state.activity_categories[activity.category][activity.subcategory]}
                                                                    default_value={activity.subsubcategory}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                         */}
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Pricing
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputDropdown
                                                                name={"pricing"}
                                                                label={""}
                                                                list={this.state.trip_pricing}
                                                                default_value={activity.pricing}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={false}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Website
                                                        </div>
                                                        <div className="trip__popup__element__content">
                                                            <ForminputText
                                                                name={"website"}
                                                                label={""}
                                                                default_value={activity.website}
                                                                setFormValue={this.updateActivity.bind(this)}
                                                                required={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="trip__popup__sectiondivider">
                                                    </div>

                                                    <div className="trip__popup__element">
                                                        <div className="trip__popup__element__label text-subtitle">
                                                            Add an address
                                                        </div>
                                                        <div className="trip__popup__element__label">
                                                            You can either search for an address or type the address or coordinates by hand.
                                                        </div>
                                                        <div className="trip__popup__element__content trip__popup__buttonbox trip__popup__buttonbox--triple">
                                                            <div onClick={() => this.changeActivityAddressMethod("search")} className={"trip__popup__buttonbox__button button" + (this.state.activity_address_method == "search" ? " trip__popup__buttonbox__button--selected" : "")}>
                                                                Search address
                                                            </div>
                                                            <div onClick={() => this.changeActivityAddressMethod("address")} className={"trip__popup__buttonbox__button button" + (this.state.activity_address_method == "address" ? " trip__popup__buttonbox__button--selected" : "")}>
                                                                Type address
                                                            </div>
                                                            <div onClick={() => this.changeActivityAddressMethod("coordinates")} className={"trip__popup__buttonbox__button button" + (this.state.activity_address_method == "coordinates" ? " trip__popup__buttonbox__button--selected" : "")}>
                                                                Type location
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {this.state.activity_address_method == "search" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Name of the location
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputText
                                                                    name={"location"}
                                                                    label={""}
                                                                    default_value={activity.location}
                                                                    setFormValue={this.updateLocationSearch.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "search" &&
                                                        <div className="trip__popup__element trip__popup__buttonbox">
                                                            {this.state.activity_location_search && this.state.activity_location_search != "" &&
                                                                <div onClick={this.searchLocation} className="button button-primary">
                                                                    Search location
                                                                </div>
                                                            }
                                                            {!(this.state.activity_location_search && this.state.activity_location_search != "") &&
                                                                <div className="button button-inactive">
                                                                    Search location
                                                                </div>
                                                            }
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "address" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Country
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputDropdown
                                                                    name={"country"}
                                                                    label={""}
                                                                    list={Object.keys(this.state.locations)}
                                                                    default_value={activity.country}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "address" && activity.country && activity.country != "" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                City
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputDropdown
                                                                    name={"city"}
                                                                    label={""}
                                                                    list={this.state.locations[activity.country]}
                                                                    default_value={activity.city}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "address" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Address
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputText
                                                                    name={"address"}
                                                                    label={""}
                                                                    default_value={activity.address}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "coordinates" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Latitude
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputText
                                                                    name={"latitude"}
                                                                    label={""}
                                                                    default_value={activity.coordinates_lat}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.activity_address_method == "coordinates" &&
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Longitude
                                                            </div>
                                                            <div className="trip__popup__element__content">
                                                                <ForminputText
                                                                    name={"longitude"}
                                                                    label={""}
                                                                    default_value={activity.coordinates_lng}
                                                                    setFormValue={this.updateActivity.bind(this)}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="trip__popup__section">
                                                        <div className="trip__popup__element">
                                                            <div className="trip__popup__element__label text-subtitle">
                                                                Pictures
                                                            </div>
                                                        </div>
                                                        <div className="trip__popup__element trip__popup__picturelist-container">

                                                            {activity.pictures.map((picture, i) => (

                                                                (typeof picture.filepath === 'string' && picture.filepath.length >= 1 &&
                                                                    <div
                                                                        key={i}
                                                                        draggable
                                                                        onDragStart={() => this.handleDragStartPictures(picture.order)}
                                                                        onDragEnd={this.handleDragEndPictures}
                                                                        onDragOver={() => this.handleDragOverPictures(picture.order)}
                                                                        className="trip__popup__picture trip__popup__picture--draggable"
                                                                    >
                                                                        {picture.filepath.endsWith(".mp4") ||
                                                                            picture.filepath.endsWith(".mov") ||
                                                                            picture.filepath.endsWith(".avi") ? (
                                                                            <video
                                                                                src={picture.filepath}
                                                                                alt={picture.label}
                                                                                className={"trip__popup__picture-inner"}
                                                                                playsInline
                                                                                controls
                                                                                muted
                                                                                preload="auto"
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                src={picture.filepath}
                                                                                alt={picture.label}
                                                                                className={"trip__popup__picture-inner"}
                                                                            />
                                                                        )}
                                                                        <div className="trip__popup__picture-overlay">
                                                                            <div onClick={() => this.setEditing("picture_editing", segment.order, "", activity.order, picture.picture_id)} className={"trip__popup__picture__icon trip__popup__picture__icon-edit"}>
                                                                                <IconEdit className="trip__popup__picture__icon-inner" />
                                                                            </div>
                                                                            <div onClick={() => this.setDeletePicture(picture.picture_id)} className={"trip__popup__picture__icon trip__popup__picture__icon-delete" + (this.state.delete_picture == picture.picture_id ? " hidden" : "")}>
                                                                                <IconDelete className="trip__popup__picture__icon-inner" />
                                                                            </div>
                                                                            <div onClick={() => this.deletePicture(segment.order, this.state.editing.activities_category, activity.order, picture.picture_id)} className={"trip__popup__picture__button text-bold" + (this.state.delete_picture == picture.picture_id ? "" : " hidden")}>
                                                                                Delete
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            ))}
                                                            <div className="trip__popup__picture">
                                                                <div className="trip__popup__picture__add-container">
                                                                    <IconAdd className="trip__popup__picture__add" />
                                                                    {!this.state.upload_image_file && !this.state.uploading &&
                                                                        <input type="file" multiple onChange={this.handleFileChangePicture} className="trip__popup__picture__add-input" />
                                                                    }
                                                                    {this.state.upload_image_file && !this.state.uploading &&
                                                                        <div onClick={() => this.addPictureActivity(segment.order, this.state.editing.activities_category, activity.order)} className="trip__popup__picture__add-submit text-bold">
                                                                            Upload
                                                                        </div>
                                                                    }
                                                                    {this.state.uploading &&
                                                                        <div className="trip__popup__picture__add-uploading text-bold">
                                                                            Uploading...
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        ))}

                                    </div>
                                )
                            ))}

                            <div className="trip__popup__section trip__popup__buttonbox">
                                <button disabled={this.state.delete_activity} onClick={this.setDeleteActivity} className={"button" + (this.state.delete_activity ? " button-inactive" : " button-primary-light")}>
                                    Delete activity?
                                </button>
                                <button disabled={!this.state.delete_activity} onClick={() => this.deleteActivity(this.state.editing.segment, this.state.editing.activities_category, this.state.editing.activity)} className={"button" + (this.state.delete_activity ? " button-primary" : " button-inactive")}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                }


                {/* Edit settings */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "settings" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>

                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Access method
                                    </div>
                                    <div className="trip__popup__element__content">
                                        Decide if your trip is discoverable on Guidr or only accessible via a unique link. Findable trips are shown on the Guidr website and anyone can find them. Link-only trips will not be shown on the Guidr website.
                                    </div>
                                    <div className="trip__popup__element__content">
                                        <div className="trip__popup__switch-container">
                                            <div onClick={() => this.setSetting("findable", false)} className={"trip__popup__switch__button" + (!this.state.data.settings.findable ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Link-only
                                                </div>
                                            </div>
                                            <div onClick={() => this.setSetting("findable", true)} className={"trip__popup__switch__button" + (this.state.data.settings.findable ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Findable
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Trip visibility
                                    </div>
                                    <div className="trip__popup__element__content">
                                        Control whether your trip is visible to everyone or only to signed-in users after unlocking. Private trips are only visible to logged-in users and can be either free of paid.  Public trips are visible to both logged-in users and people without a Guidr account and are always free.
                                    </div>
                                    <div className="trip__popup__element__content">
                                        <div className="trip__popup__switch-container">
                                            <div onClick={() => this.setSetting("public", false)} className={"trip__popup__switch__button" + (!this.state.data.settings.public ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Private
                                                </div>
                                            </div>
                                            <div onClick={() => this.setSetting("public", true)} className={"trip__popup__switch__button" + (this.state.data.settings.public ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Public
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Trip pricing
                                    </div>
                                    <div className="trip__popup__element__content">
                                        Choose if your trip is free for travelers or if a price will be charged. You will earn 80% of the price charged for your trip, the rest will be used to cover Guidr's costs, like maintaining the platform and marketing your trip.
                                    </div>
                                    <div className="trip__popup__element__content">
                                        <div className="trip__popup__switch-container">
                                            <div onClick={() => this.setSetting("paid", false)} className={"trip__popup__switch__button" + (!this.state.data.settings.paid ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Free
                                                </div>
                                            </div>
                                            <div onClick={() => this.setSetting("paid", true)} className={"trip__popup__switch__button" + (this.state.data.settings.paid ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Paid
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.data.settings.paid &&
                                <div className="trip__popup__section">
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__content">
                                            Set the price you want to charge for your trip.
                                        </div>
                                        <div className="trip__popup__element__content">
                                            This feature is currently not available. Please come back soon.

                                            {/* <div className="trip__popup__switch-container">
                                                <div onClick={() => this.setSetting("price", 4)} className={"trip__popup__switch__button" + (parseInt(this.state.data.settings.price) === 4 ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        {format_price(4)}
                                                    </div>
                                                </div>
                                                <div onClick={() => this.setSetting("price", 8)} className={"trip__popup__switch__button" + (parseInt(this.state.data.settings.price) === 8 ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        {format_price(8)}
                                                    </div>
                                                </div>
                                                <div onClick={() => this.setSetting("price", 12)} className={"trip__popup__switch__button" + (parseInt(this.state.data.settings.price) === 12 ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        {format_price(12)}
                                                    </div>
                                                </div>
                                                <div onClick={() => this.setSetting("price", 20)} className={"trip__popup__switch__button" + (parseInt(this.state.data.settings.price) === 20 ? " trip__popup__switch__button--selected" : "")}>
                                                    <div className="trip__popup__switch__button__icon">
                                                        <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                    </div>
                                                    <div className="trip__popup__switch__button__label">
                                                        {format_price(20)}
                                                    </div>
                                                </div>
                                            </div> */}

                                        </div>
                                        <div className="trip__popup__element__content">
                                            You will earn {(this.state.data.settings.price && this.state.data.settings.price > 0 ? format_price(this.state.data.settings.price * 0.8) + " (80%)." : " 80% of the price.")} We will retain 20% to invest in our platform and to market your trip itineraries.
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Trip status
                                    </div>
                                    <div className="trip__popup__element__content">
                                        Deactivate the trip to make it unavailable for others or activate it for use. Deactivated trips are not available to anyone, except you. You can reactivate them at any time.
                                    </div>
                                    <div className="trip__popup__element__content">
                                        <div className="trip__popup__switch-container">
                                            <div onClick={() => this.setSetting("active", false)} className={"trip__popup__switch__button" + (!this.state.data.settings.active ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Deactivated
                                                </div>
                                            </div>
                                            <div onClick={() => this.setSetting("active", true)} className={"trip__popup__switch__button" + (this.state.data.settings.active ? " trip__popup__switch__button--selected" : "")}>
                                                <div className="trip__popup__switch__button__icon">
                                                    <IconCheckmark className="trip__popup__switch__button__icon-inner" />
                                                </div>
                                                <div className="trip__popup__switch__button__label">
                                                    Active
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Permanently delete trip
                                    </div>
                                    <div className="trip__popup__element__content">
                                        Permanently delete this trip. This action cannot be undone and the trip will be removed from Guidr.
                                    </div>
                                    <div className="trip__popup__element trip__popup__buttonbox">
                                        <button disabled={this.state.delete_trip} onClick={() => this.setDeleteTrip()} className={"button" + (this.state.delete_trip ? " button-inactive" : " button-primary-light")}>
                                            Delete trip
                                        </button>
                                        {this.state.delete_trip &&
                                            <button disabled={!this.state.delete_trip} onClick={() => this.deleteTrip()} className={"button" + (this.state.delete_trip ? " button-primary" : " button-inactive")}>
                                                Delete
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }

                {/* Show QR code */}
                {this.state.owner && this.state.data.trip_id && this.state.editing.page === "qrcode" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={this.unsetEditing} className="trip__popup__close" />
                            </div>

                            <QRcode
                                url={this.props.webUrl + "/trip/" + this.state.data.trip_id}
                                title={"QR code for this trip"}
                                description={""}
                            />

                        </div>
                    </div>
                }

                {/* Show actionbar when owner is logged in and changes have happened */}
                {this.state.login && this.state.owner && this.state.data.trip_id && this.state.changes &&
                    <div className="trip__actionbar-container">
                        <div className="trip__actionbar">
                            <div className="trip__actionbar__label text-bold">
                                You have unsaved changes
                            </div>
                            <div onClick={this.discardChanges} className="trip__actionbar__button button button-primary-light">
                                Discard changes
                            </div>
                            <div onClick={this.saveChanges} className="trip__actionbar__button button button-primary">
                                Save changes
                            </div>
                        </div>
                    </div>
                }

                {/* Show navigation bar when other user is logged in or no changes have happened */}
                {(this.state.data.trip_id && !this.state.changes && !this.state.missingdata) &&
                    (this.state.data.segments.length > 1 &&
                        <div className="trip__navigationbar-container">
                            <div className="trip__navigationbar-wrapper">
                                <TripNavigationBar
                                    segments={this.state.data.segments}
                                    active_index={this.state.active_index}
                                    scrollToSection={this.scrollToSection}
                                />
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}

export default withRouter(Trip);